import { gql } from '@apollo/client/core';
import apolloClient from './apolloClient.js';

export interface AbracadabraInput {
	problemType: string;
	pageId: number;
}

export interface AdPageInput {
	magazineId: number;
}

export interface ApiKey {
	id: number;
	name: string;
	description: string;
	key: string;
	createdAt: string;
}

export interface ApiKeyInput {
	id: number;
	name: string;
	description: string;
}

export interface Article {
	articleId: number;
	articleNumber: string;
	productID: number;
}

export interface ArticleData {
	exists: boolean;
	pageId: number;
	productId: number;
	purchaserId: number;
	templateId: number;
	fields: ProductCustomField[];
	picture: ProductPicture[];
	logo: ProductLogo[];
}

export interface ArticleInformation {
	articleNumbers: string[];
	articlePurchaser: Purchaser[];
	purchaser: Purchaser;
}

export interface ArticleInput {
	articleNumber: string;
	productId: number;
	pageId: number;
	virtualId: number;
	teamId: number;
}

export interface ArticleNumber {
	marketId: number;
	position: string;
	size: number;
}

export interface ArticleNumberSearch {
	id: number;
	produktName: string;
	pagePosition: number;
	magazineName: string;
	marketName: string;
	marketDescription: string;
	magazineId: number;
	marketId: number;
	projektId: number;
}

export interface ArticleTemplateGroup {
	idArticleTemplateGroup: number;
	name: string;
}

export interface ArtikelInformation {
	fields: BaseArticleField[];
}

export interface AssetSearchResult {
	image: ImageData[];
	numberOfImages: number;
}

export interface AttributeInput {
	magazineTypeId: number;
	formularName: string;
	formularId: number;
}

export interface BaseArticle {
	articleNumber: string;
	productId: number;
	teamId: number;
	fields: BaseArticleField[];
}

export interface BaseArticleField {
	fieldId: number;
	fieldName: string;
	fieldValue: string;
}

export interface BaseArticleFieldInput {
	fieldId: number;
	fieldName: string;
	fieldValue: string;
}

export interface BaseArticleInput {
	articleNumber: string;
	productId: number;
	teamId: number;
	fields: BaseArticleFieldInput[];
}

export interface CheckPlaceResult {
	success: boolean;
	code: string;
	products: CheckPlaceResultProduct[];
}

export interface CheckPlaceResultArticleNumbers {
	articleNumber: string;
	success: boolean;
	code: string;
	message: string;
}

export interface CheckPlaceResultMarket {
	success: boolean;
	articleNumber: string;
	marketIds: number[];
	code: string;
}

export interface CheckPlaceResultProduct {
	articleNumber: string;
	productId: number;
	virtualId: number;
	productPosition: number;
	placeholderPosition: number;
}

export interface Clipboard {
	clipboardId: number;
	clipboardProduktId: number;
	clipboardPageID: number;
	clipboardTime: number;
	clipboardUserId: number;
	clipboardVision: string;
	articleID: number;
	articleNumber: string;
}

export interface ClipboardInput {
	pageID: number;
	productID: number;
	articleNumberId: number;
	clipboardId: number;
	virtualId: number;
}

export interface ColumnFilterInput {
	column: string;
	operator: string;
	value: string;
}

export interface CreateMarketInput {
	name: string;
	description: string;
	isActive: string;
	customFieldValues: customFieldValues[];
}

export interface CustomField {
	idProductCustomField: number;
	fieldName: string;
	dontCopy: boolean;
	ignoreOnPlaceProduct: boolean;
}

export interface CustomFieldInput {
	productFieldId: number;
	fieldName: string;
	dontCopy: boolean;
	ignoreOnPlaceProduct: boolean;
}

export interface Debug {
	message: string;
}

export interface EditClipboardInput {
	pageID: number;
	productID: number;
	virtualId: number;
}

export interface ExcelDataInput {
	productNumber: string;
	customFields: ProductCustomFieldInput[];
	markets: PlacedMarket[];
}

export interface ExportImages {
	imgLocNewFilename: string;
	imgLocID: number;
	imgLocProductName: string;
}

export interface FieldLabel {
	id: number;
	label: string;
	field: string;
}

export interface FieldsInput {
	productCustomFieldId: number;
	productId: number;
	field: string;
	value: string;
}

export interface FormFieldInput {
	formFieldId: number;
	lapel: string;
	inputType: string;
	readOnly: boolean;
	fieldName: string;
}

export interface FormHeaderInput {
	idProductFormHeader: number;
	idProductForm: number;
	label: string;
	field: string;
	size: string;
	deleted: boolean;
	position: number;
}

export interface FormInputs {
	id: number;
	groupID: number;
	label: string;
	position: number;
	field: string;
	formularType: string;
	value: string;
	readOnly: boolean;
	formularId: number;
	deleted: boolean;
}

export interface FormListInput {
	idProductFormList: number;
	idProductForm: number;
	label: string;
	field: string;
	size: string;
	deleted: boolean;
	position: number;
	type: string;
}

export interface FormListMarketInput {
	idProductFormListMarket: number;
	idProductForm: number;
	label: string;
	field: string;
	mainSize: string;
	textSize: string;
	type: string;
	deleted: boolean;
	position: number;
}

export interface Formular {
	id: number;
	groupID: number;
	formularType: string;
	label: string;
	value: string;
	fieldValue: string;
	image: string;
	readOnly: boolean;
	field: string;
}

export interface FormularGroup {
	id: number;
	name: string;
	groupType: string;
	traderID: number;
}

export interface FormularInput {
	formularName: string;
	magazineTypeID: number;
}

export interface FormularName {
	idForm: number;
	name: string;
	magazineType: number;
}

export interface Grid {
	pageTemplateName: string;
	pageHeight: number;
	pageWidth: number;
	marginTop: number;
	marginBottom: number;
	marginLeft: number;
	marginRight: number;
	cutTop: number;
	cutBottom: number;
	cutLeft: number;
	cutRight: number;
	columns: number;
	rows: number;
	columnGap: number;
	rowGap: number;
	userPurchaseIds: number[];
	placeholders: Placeholder[];
}

export interface GridInput {
	pageHeight: number;
	pageWidth: number;
	marginTop: number;
	marginBottom: number;
	marginLeft: number;
	marginRight: number;
	cutTop: number;
	cutBottom: number;
	cutLeft: number;
	cutRight: number;
	columns: number;
	rows: number;
	columnGap: number;
	rowGap: number;
	originalPlaceholders: OriginalPlaceholder[];
	placeholders: PlaceholderInput[];
}

export interface HistoryInput {
	typeVar: string;
	fieldName: string;
	filename: string;
	created: number;
	modified: number;
	name: string;
	value: string;
	magazineID: number;
	projectID: number;
	pageID: number;
	articleNumber: string;
}

export interface HistoryResult {
	historyId: number;
	historyTime: string;
	historyIdPage: number;
	historyIdProdukt: number;
	username: string;
	historyData: string;
	type: string;
	fieldName: string;
	oldData: string;
	newData: string;
	oldValue: string;
	newValue: string;
	filename: string;
	created: string;
	modified: string;
	name: string;
	value: string;
}

export interface IdName {
	id: number;
	name: string;
}

export interface Image {
	imageId: number;
	type: string;
}

export interface ImageData {
	imgLocID: number;
	imgLocProductName: string;
	imgLocOrgFilepath: string;
	imgLocOrgFilename: string;
	imgLocFileModDate: string;
	imgLocMarkedForDeletion: string;
	imgLocGo2pict: string;
	IMGLocGo2pictClass: string;
	imgLocMainFileSize: string;
	imgLocArticleNumber: string;
	imgLocNewFilepath: string;
	imgLocNewFilename: string;
	imgLocGo2pictIDPicture: number;
	imgLocGo2pictIDProductPic: number;
	imgLocImagWithOrg: number;
	imgLocImagHightOrg: number;
	imgLocImagDpiOrg: number;
	isInFavorite: number;
	pictureLink: string;
	purchaserID: number;
}

export interface ImageInputEdit {
	imageID: number[];
	position: number[];
	typeImage: string;
}

export interface ImageSearchFilter {
	searchTerm: string;
	team: number;
	type: string;
}

export interface ImageSearchResult {
	id: number;
	previewSmall: string;
	previewMedium: string;
	previewLarge: string;
	type: string;
	timestampUpdated: number;
	timestampCreated: number;
	isDeleted: boolean;
	name: string;
	dateTimeCreated: string;
	dateTimeUpdated: string;
}

export interface ImportClass {
	idPictureClass: number;
	pictureClass: string;
	position: number;
	useFilter: boolean;
}

export interface InDesignRule {
	id: number;
	name: string;
	layout: string;
	script: string;
	timestamp: number;
	userId: number;
	description: string;
}

export interface InDesignRuleInput {
	id: number;
	name: string;
	layout: string;
	script: string;
	description: string;
}

export interface InDesignTemplate {
	id: number;
	name: string;
	type: string;
	exists: boolean;
}

export interface InDesignTemplateCategory {
	id: number;
	name: string;
	type: string;
}

export interface InDesignTemplateInfo {
	id: number;
	type: string;
	name: string;
	width: number;
	height: number;
	magazineTypeId: number;
	isHidden: boolean;
	isDefault: boolean;
	defaultForSize: boolean;
	defaultForPageSide: string;
	backupTimestamps: string[];
}

export interface InDesignTemplateInfoInput {
	id: number;
	type: string;
	name: string;
	width: number;
	height: number;
	magazineTypeId: number;
	isHidden: boolean;
	isDefault: boolean;
	defaultForSize: boolean;
	defaultForPageSide: string;
}

export interface KeyValue {
	key: string;
	value: string;
}

export interface KeyValueInput {
	key: string;
	value: string;
}

export interface ListViewFieldInput {
	productId: number;
	marketId: number;
	value: string;
	key: string;
}

export interface ListViewProduct {
	productId: number;
	marketId: number;
	action: string;
	virtualId: number;
	productPosition: number;
}

export interface LogoInformation {
	productLogoId: number;
	pictureId: number;
	isActive: boolean;
	position: number;
	markedForDeletion: boolean;
	isRemoved: boolean;
}

export interface LogoInput {
	productJoinProductLogoId: number;
	productLogoId: number;
	teamId: number;
	isActive: boolean;
	previewSmall: string;
	previewMedium: string;
	previewLarge: string;
	position: number;
	markedForDeletion: boolean;
	name: string;
	dateTimeCreated: string;
	dateTimeUpdated: string;
	delete: boolean;
	added: boolean;
	originalFilePath: string;
	isRemoved: boolean;
}

export interface Magazine {
	magazineId: number;
	lock: boolean;
	name: string;
	numberOfPages: number;
	pages: Page[];
	magazineType: string;
	magazineTypeId: number;
	from: number;
	to: number;
	printNumber: string;
	mmW: string;
	mmH: string;
}

export interface MagazineInput {
	projektId: number;
	magazineId: number;
	magazineName: string;
	selectedSize: string;
	mmW: number;
	mmH: number;
	pageCount: number;
	magazineTypeID: number;
	copyData: boolean;
	copyPurchaser: boolean;
	formart: string;
	printNumber: string;
}

export interface MagazineInputValue {
	magazineId: number;
	name: string;
	from: string;
	to: string;
	printNumber: string;
}

export interface MagazineType {
	magazineTypeId: number;
	magazineType: string;
	magazineTypeTitle: string;
	supportMarkets: boolean;
}

export interface MagazineTypeInput {
	magazineTypeId: number;
	magazineType: string;
	magazineTypeTitle: string;
	supportsMarkets: boolean;
}

export interface Market {
	marketId: number;
	name: string;
	description: string;
	isActive: boolean;
	sapMarketName: string;
}

export interface MarketCustomField {
	idCustomField: number;
	fieldValue: string;
	fieldName: string;
	label: string;
}

export interface MarketCustomFieldValue {
	idCustomFieldValue: number;
	idCustomField: number;
	idMarket: number;
	fieldValue: string;
	fieldName: string;
	label: string;
}

export interface MarketInfo {
	marketId: number;
	name: string;
	description: string;
	isActive: string;
	templateId: number;
}

export interface MarketInput {
	marketId: number;
	name: string;
	description: string;
	isActive: boolean;
	delete: boolean;
	customFieldValues: customFieldValues[];
	sapMarketName: string;
}

export interface MarketPlaceholders {
	marketId: number;
	marketName: string;
	placeholders: PlaceholderMarkets[];
}

export interface MarketStatus {
	marketId: number;
	name: string;
	description: string;
	isActive: boolean;
	isFull: boolean;
	sapMarketName: string;
}

export interface MarketTypeInput {
	magazineType: string;
	magazineTypeTitle: string;
	supportsMarkets: boolean;
}

export interface NewsLetterData {
	magazineId: number;
	data: string;
}

export interface NewsletterImportArticle {
	articleNumber: string;
	magazineId: number;
	marketId: number;
}

export interface OriginalPlaceholder {
	id: number;
	arrX: number;
	arrY: number;
	x: number;
	y: number;
	width: number;
	height: number;
}

export interface Package {
	name: string;
	description: string;
	version: string;
	company: string;
	author: string;
	email: string;
	website: string;
	license: string;
	actions: PackageAction[];
}

export interface PackageAction {
	title: string;
	script: string;
}

export interface Page {
	pageId: number;
	isOnMarket: boolean;
	lock: boolean;
	projectId: number;
	marketId: number;
	magazineId: number;
	magazinePageCount: number;
	team: Team[];
	magazineTypeId: number;
	magazineTypeName: string;
	pagePosition: number;
	name: string;
	attributes: KeyValue[];
	products: Product[];
	pageTemplateId: number;
	hooks: string[];
}

export interface PageInfo {
	projectId: number;
	projectName: string;
	magazineId: number;
	magazineName: string;
	pageId: number;
	pageName: string;
	pagePosition: number;
	marketId: number;
	marketName: string;
}

export interface PageInput {
	magazineId: number;
	pagePosition: number;
	attributes: KeyValueInput[];
	products: ProductInput[];
}

export interface PageList {
	markets: PageListMarket[];
	products: PageListProduct[];
}

export interface PageListMarket {
	marketId: number;
	marketName: string;
	isActive: boolean;
	marketDescription: string;
	pageId: number;
	marketTeams: PageListMarketTeam[];
}

export interface PageListMarketTeam {
	teamId: number;
	placeholderUsed: number;
	placeholderTotal: number;
}

export interface PageListProduct {
	articleNumber: string;
	productId: number;
	teamId: number;
	placedOnTeamId: number;
	teamIcon: string;
	teamColor: string;
	markets: PageListProductMarket[];
}

export interface PageListProductMarket {
	marketId: number;
	customFields: ProductCustomFieldList[];
}

export interface PagePosition {
	pageID: number;
	position: number;
}

export interface PageSections {
	pageID: number;
	teams: Team[];
	teamsForPlaceholder: KeyValue[];
}

export interface PageTeamInput {
	teamId: number[];
	pageId: number;
	placeholder: PlaceholderTeamInput[];
	marketIds: number[];
}

export interface PageTemplate {
	pageTemplateId: number;
	name: string;
	groupId: number;
}

export interface PageTemplateFilter {
	magazineType: string;
	copy: boolean;
}

export interface PageTemplateGroup {
	idPageTemplateGroup: number;
	name: string;
}

export interface PageTemplateInput {
	templateId: number;
	name: string;
	magazineTypeId: number;
}

export interface PictureInformation {
	productPictureId: number;
	pictureId: number;
	isVisibleInGo2Pict: boolean;
	position: number;
}

export interface PictureInput {
	productJoinProductPictureId: number;
	productPictureId: number;
	teamId: number;
	isActive: boolean;
	previewSmall: string;
	previewMedium: string;
	previewLarge: string;
	position: number;
	markedForDeletion: boolean;
	isDefault: boolean;
	name: string;
	dateTimeCreated: string;
	dateTimeUpdated: string;
	delete: boolean;
	added: boolean;
	originalFilePath: string;
	isRemoved: boolean;
}

export interface PlaceProductOnMarketInput {
	articleNumber: string;
	magazineId: number;
	pagePosition: number;
	placeHolderMarkets: placeHoldersForMarkets[];
}

export interface PlaceProductOnPageInput {
	pageId: number;
	placeholderId: number;
	articleNumber: string;
}

export interface PlaceProductsInput {
	productId: number;
	marketId: number;
}

export interface PlaceProductsOnPageInput {
	pageId: number;
	placeABCArticle: boolean;
	articleNumbers: string[];
	virtualId: number;
}

export interface PlacedMarket {
	marketName: string;
	placed: boolean;
	regional: boolean;
}

export interface Placeholder {
	x: number;
	y: number;
	width: number;
	height: number;
	position: number;
	virtualId: number;
	purchaser: Purchaser[];
	article: PlaceholderArticle[];
	originalPlaceholdersIndex: number[];
}

export interface PlaceholderArticle {
	articleNumber: string;
	virtualId: number;
}

export interface PlaceholderInput {
	x: number;
	y: number;
	width: number;
	height: number;
	originalPlaceholdersIndex: number[];
	purchaser: number[];
}

export interface PlaceholderMarkets {
	isEmpty: boolean;
	placeholderId: number;
	productPosition: number;
	purchaser: Purchaser[];
}

export interface PlaceholderTeamInput {
	teamId: number[];
	virtualId: number;
}

export interface PrintInfo {
	projectName: string;
	magazineName: string;
	pages: PrintPage[];
}

export interface PrintPage {
	pageId: number;
	pagePosition: number;
	marketName: string;
}

export interface Product {
	productId: number;
	articleNumber: string;
	placeholderId: number;
	placeholderWidth: number;
	placeholderHeight: number;
	placeholderPosition: number;
	productPosition: number;
	productCustomFields: ProductCustomField[];
	productTemplate: ProductTemplate;
	productTemplateId: number;
	productTemplateName: string;
	productPictures: ProductPicture[];
	productLogos: ProductLogo[];
	teamIcon: string;
	isVirtualArticle: boolean;
	virtualProjektId: number;
	virtualMagazineId: number;
	virtualPagePosition: number;
	virtualMarketId: number;
	virtualProjektName: string;
	virtualMagazineName: string;
	virtualMarketName: string;
	virtualOriginalLastChange: number;
	virtualAccordionIndex: number;
	teamColor: string;
	marketIds: number[];
}

export interface ProductCustomField {
	productCustomFieldId: number;
	productId: number;
	field: string;
	value: string;
}

export interface ProductCustomFieldInput {
	field: string;
	value: string;
}

export interface ProductCustomFieldList {
	productCustomFieldId: number;
	productId: number;
	field: string;
	originalValue: string;
	value: string;
}

export interface ProductField {
	articleNumbers: string[];
	virtualId: number;
	index: number;
}

export interface ProductFormField {
	type: string;
	field: string;
	label: string;
	readOnly: boolean;
	image: string;
	value: string;
}

export interface ProductFormFieldGroup {
	type: string;
	name: string;
	fields: ProductFormField[];
}

export interface ProductFormHeader {
	idProductFormHeader: number;
	idProductForm: number;
	label: string;
	field: string;
	size: string;
}

export interface ProductFormList {
	idProductFormList: number;
	idProductForm: number;
	label: string;
	field: string;
	size: string;
	type: string;
}

export interface ProductFormListMarket {
	idProductFormListMarket: number;
	idProductForm: number;
	label: string;
	field: string;
	mainSize: string;
	textSize: string;
	type: string;
}

export interface ProductInfo {
	virtualId: number;
	articleNumber: string;
	productId: number;
	productPosition: number;
	teamId: number;
}

export interface ProductInput {
	articleNumber: string;
	productId: number;
	productTemplateId: number;
	marketIds: number[];
	pictures: ProductPictureInput[];
	logos: ProductLogoInput[];
	productCustomFields: ProductCustomFieldInput[];
}

export interface ProductLogo {
	productJoinProductLogoId: number;
	productLogoId: number;
	teamId: number;
	isActive: boolean;
	originalFilePath: string;
	previewSmall: string;
	previewMedium: string;
	previewLarge: string;
	position: number;
	markedForDeletion: boolean;
	name: string;
	dateTimeCreated: string;
	dateTimeUpdated: string;
	delete: boolean;
}

export interface ProductLogoInput {
	productLogoId: number;
	pictureId: number;
	isActive: boolean;
	position: number;
	markedForDeletion: boolean;
	isRemoved: boolean;
}

export interface ProductPicture {
	productJoinProductPictureId: number;
	productPictureId: number;
	teamId: number;
	isActive: boolean;
	originalFilePath: string;
	previewSmall: string;
	previewMedium: string;
	previewLarge: string;
	position: number;
	markedForDeletion: boolean;
	isDefault: boolean;
	name: string;
	dateTimeCreated: string;
	dateTimeUpdated: string;
	delete: boolean;
}

export interface ProductPictureInfo {
	name: string;
	changed: string;
	added: string;
}

export interface ProductPictureInput {
	productPictureId: number;
	pictureId: number;
	isActive: boolean;
	position: number;
	markedForDeletion: boolean;
	isDefault: boolean;
	isRemoved: boolean;
}

export interface ProductTemplate {
	productTemplateId: number;
	name: string;
}

export interface Progress {
	processed: number;
	status: string;
	id: number;
	report: Report;
}

export interface Project {
	projectId: number;
	name: string;
	startTimestamp: number;
	endTimestamp: number;
	lock: boolean;
	isActive: boolean;
	magazines: Magazine[];
}

export interface ProjectInput {
	name: string;
	from: number;
	to: number;
}

export interface ProjectInputValue {
	projectId: number;
	name: string;
	from: string;
	to: string;
}

export interface Purchaser {
	id: number;
	name: string;
	teamPosition: number;
	teamIcon: string;
	color: string;
}

export interface PurchaserField {
	id: number;
	virtualId: number;
	index: number;
}

export interface PurchaserGrid {
	idPageJTeamGrid: number;
	idPage: number;
	idTeam: number;
	posX: number;
	posY: number;
	virtualId: number;
}

export interface QueryFilter {
	projectId: number;
	magazineId: number;
	pageId: number;
	pageTemplateId: number;
	marketId: number;
	productId: number;
	productTemplateId: number;
	productCustomFieldId: number;
	userScoped: boolean;
}

export interface Report {
	jopId: number;
	success: boolean;
	errors: ReportMessage[];
	messages: ReportMessage[];
}

export interface ReportMessage {
	code: string;
	message: string;
	data: KeyValue[];
}

export interface Rule {
	id: number;
	hook: string;
	script: string;
	title: string;
}

export interface RuleInput {
	id: number;
	title: string;
	hook: string;
	script: string;
}

export interface SaveArticleNumberInput {
	purchaserId: number;
	saveInBaseArticle: boolean;
	articleNumber: string;
	magazineId: number;
	marketId: number;
	fields: FieldsInput[];
	picture: PictureInput[];
	logo: LogoInput[];
}

export interface SaveListViewInput {
	magazineId: number;
	pagePosition: number;
	products: ListViewProduct[];
	listViewFields: ListViewFieldInput[];
	placeProducts: PlaceProductsInput[];
	removedProducts: removeProductInput[];
}

export interface SortInputs {
	sortProducts: sort[];
	pageId: number;
}

export interface SortType {
	virtualId: number;
	positionTitle: string;
	productInfo: ProductInfo[];
}

export interface Statement {
	id: number;
	statement: string;
	name: string;
}

export interface Success {
	success: boolean;
	code: string;
	message: string;
	values: KeyValue[];
	id: number;
}

export interface SuccessFeedBack {
	success: boolean;
	code: string;
	message: string;
	values: KeyValue[];
	articleNumbers: string[];
}

export interface SuccessNewsLetter {
	success: boolean;
	code: string;
	message: string;
	values: KeyValue[];
	ids: number[];
	articleNumbers: string[];
}

export interface TableData {
	columns: string[];
	rows: string[][];
	totalCount: number;
}

export interface TableDataInput {
	id: number;
	idName: string;
	value: string;
	columnName: string;
}

export interface Team {
	id: number;
	tag: string;
	name: string;
	color: string;
}

export interface TeamInput {
	name: string;
	iconName: string;
	color: string;
}

export interface TeamInputEdit {
	id: number;
	name: string;
	icon: string;
	color: string;
}

export interface TemplateFilter {
	width: number;
	height: number;
}

export interface TemplateInput {
	width: number;
	height: number;
	templateGroupId: number;
	option: string;
	searchTerm: string;
}

export interface TemplateInputInfo {
	name: string;
	magazineType: number;
	copy: boolean;
}

export interface TemplateSearchResult {
	templateId: number;
	templateName: string;
	templateHeight: number;
	templateWidth: number;
	templateTimestamp: string;
}

export interface TimeTravelPoint {
	timeTravelPointId: number;
	title: string;
	timestamp: number;
	pageId: number;
}

export interface User {
	userId: number;
	userName: string;
	lastUpdateTimestamp: number;
	language: string;
}

export interface UserInfo {
	client: string;
	userId: number;
	originalUserId: number;
	userName: string;
	lastUpdateTimestamp: number;
	language: string;
	userMail: string;
	userPhone: string;
	purchasingIds: number[];
	isAdmin: boolean;
	isMarketing: boolean;
	isSuperAdmin: boolean;
}

export interface UserInput {
	name: string;
	mail: string;
	password: string;
	phone: string;
	language: string;
	role: number;
}

export interface UserInputEdit {
	userID: number;
	name: string;
	login: string;
	mail: string;
	phone: string;
	selectedTeamIds: number[];
	role: number;
}

export interface UserInputInformation {
	userID: number;
	name: string;
	mail: string;
	phone: string;
}

export interface UserMagazine {
	magazineId: number;
	magazineName: string;
	lock: boolean;
	pages: UserPage[];
}

export interface UserPage {
	pageId: number;
	pageName: string;
	lock: boolean;
	pagePosition: number;
	marketId: number;
}

export interface UserProfile {
	userId: number;
	userName: string;
	login: string;
	lastUpdateTimestamp: number;
	language: string;
	userMail: string;
	userPhone: string;
	role: number;
	purchasingIds: number[];
}

export interface UserProject {
	projectId: number;
	projectName: string;
	lock: boolean;
	magazines: UserMagazine[];
}

export interface customFieldValues {
	idMarketCustomField: number;
	fieldValue: string;
}

export interface placeHoldersForMarkets {
	marketId: number;
	placeholderId: number;
}

export interface placeProductInput {
	magazineId: number;
	articleNumber: string;
	marketId: number[];
	virtualId: number;
}

export interface removeProductInput {
	productId: number;
	marketId: number;
}

export interface sort {
	articleNumber: string;
	productId: number;
	virtualId: number;
	productPosition: number;
}

async function JSONExport(magazineID: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation JSONExport($magazineID: Int!) {
					JSONExport(magazineID: $magazineID) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineID: magazineID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.JSONExport) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.JSONExport, null];
	} catch (error) {
		return [null, error];
	}
}

async function activityHistory(pageId: number, productId: number): Promise<[HistoryResult[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query activityHistory($pageId: Int!, $productId: Int!) {
					activityHistory(pageId: $pageId, productId: $productId) {
						historyId 
						historyTime 
						historyIdPage 
						historyIdProdukt 
						username 
						historyData 
						type 
						fieldName 
						oldData 
						newData 
						oldValue 
						newValue 
						filename 
						created 
						modified 
						name 
						value 
					}
				}
				`),
			variables: {
								pageId: pageId,
				productId: productId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.activityHistory) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.activityHistory, null];
	} catch (error) {
		return [null, error];
	}
}

async function articleLink(virtualId: number, linkPageID: number, magazineID: number, pagePosition: number, marketId: number, productId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation articleLink($virtualId: Int!, $linkPageID: Int!, $magazineID: Int!, $pagePosition: Int!, $marketId: Int!, $productId: Int!) {
					articleLink(virtualId: $virtualId, linkPageID: $linkPageID, magazineID: $magazineID, pagePosition: $pagePosition, marketId: $marketId, productId: $productId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								virtualId: virtualId,
				linkPageID: linkPageID,
				magazineID: magazineID,
				pagePosition: pagePosition,
				marketId: marketId,
				productId: productId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.articleLink) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.articleLink, null];
	} catch (error) {
		return [null, error];
	}
}

async function changeArticle(magazineId: number, pagePosition: number, newArticleNumber: string, productId: number, marketIds: number[]): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation changeArticle($magazineId: Int!, $pagePosition: Int!, $newArticleNumber: String!, $productId: Int!, $marketIds: [Int!]!) {
					changeArticle(magazineId: $magazineId, pagePosition: $pagePosition, newArticleNumber: $newArticleNumber, productId: $productId, marketIds: $marketIds) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition,
				newArticleNumber: newArticleNumber,
				productId: productId,
				marketIds: marketIds
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.changeArticle) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.changeArticle, null];
	} catch (error) {
		return [null, error];
	}
}

async function changeImageLock(imageID: number, typeImage: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation changeImageLock($imageID: Int!, $typeImage: String!) {
					changeImageLock(imageID: $imageID, typeImage: $typeImage) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								imageID: imageID,
				typeImage: typeImage
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.changeImageLock) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.changeImageLock, null];
	} catch (error) {
		return [null, error];
	}
}

async function changeMagazineLock(magazineId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation changeMagazineLock($magazineId: Int!) {
					changeMagazineLock(magazineId: $magazineId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineId: magazineId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.changeMagazineLock) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.changeMagazineLock, null];
	} catch (error) {
		return [null, error];
	}
}

async function changePageLock(pageID: number, marktIds: number[], lock: boolean): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation changePageLock($pageID: Int!, $marktIds: [Int!]!, $lock: Boolean!) {
					changePageLock(pageID: $pageID, marktIds: $marktIds, lock: $lock) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageID: pageID,
				marktIds: marktIds,
				lock: lock
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.changePageLock) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.changePageLock, null];
	} catch (error) {
		return [null, error];
	}
}

async function changePageTemplate(pageId: number, pageTemplateId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation changePageTemplate($pageId: Int!, $pageTemplateId: Int!) {
					changePageTemplate(pageId: $pageId, pageTemplateId: $pageTemplateId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				pageTemplateId: pageTemplateId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.changePageTemplate) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.changePageTemplate, null];
	} catch (error) {
		return [null, error];
	}
}

async function changePageTemplateWithProducts(pageId: number, pageTemplateId: number, purchasers: PurchaserField[], products: ProductField[], grid: GridInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation changePageTemplateWithProducts($pageId: Int!, $pageTemplateId: Int!, $purchasers: [PurchaserField!]!, $products: [ProductField!]!, $grid: GridInput!) {
					changePageTemplateWithProducts(pageId: $pageId, pageTemplateId: $pageTemplateId, purchasers: $purchasers, products: $products, grid: $grid) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				pageTemplateId: pageTemplateId,
				purchasers: purchasers,
				products: products,
				grid: grid
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.changePageTemplateWithProducts) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.changePageTemplateWithProducts, null];
	} catch (error) {
		return [null, error];
	}
}

async function changeProjectLock(projectId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation changeProjectLock($projectId: Int!) {
					changeProjectLock(projectId: $projectId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								projectId: projectId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.changeProjectLock) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.changeProjectLock, null];
	} catch (error) {
		return [null, error];
	}
}

async function checkIfArticleIsOnMagazinePage(magazineId: number, articleNumber: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation checkIfArticleIsOnMagazinePage($magazineId: Int!, $articleNumber: String!) {
					checkIfArticleIsOnMagazinePage(magazineId: $magazineId, articleNumber: $articleNumber) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				articleNumber: articleNumber
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.checkIfArticleIsOnMagazinePage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.checkIfArticleIsOnMagazinePage, null];
	} catch (error) {
		return [null, error];
	}
}

async function checkIfProductIsOnMarket(productId: number, marketId: number, magazineId: number): Promise<[CheckPlaceResult | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation checkIfProductIsOnMarket($productId: Int!, $marketId: Int!, $magazineId: Int!) {
					checkIfProductIsOnMarket(productId: $productId, marketId: $marketId, magazineId: $magazineId) {
						success 
						code 
						products {
							articleNumber 
							productId 
							virtualId 
							productPosition 
							placeholderPosition 
						}
					}
				}
				`),
			variables: {
								productId: productId,
				marketId: marketId,
				magazineId: magazineId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.checkIfProductIsOnMarket) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.checkIfProductIsOnMarket, null];
	} catch (error) {
		return [null, error];
	}
}

async function clearPurchaserGroup(magazineId: number, pagePosition: number, productId: number, teamId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation clearPurchaserGroup($magazineId: Int!, $pagePosition: Int!, $productId: Int!, $teamId: Int!) {
					clearPurchaserGroup(magazineId: $magazineId, pagePosition: $pagePosition, productId: $productId, teamId: $teamId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition,
				productId: productId,
				teamId: teamId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.clearPurchaserGroup) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.clearPurchaserGroup, null];
	} catch (error) {
		return [null, error];
	}
}

async function copyDataFromLinktArticle(magazineID: number, marketID: number, placedPageID: number, productID: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation copyDataFromLinktArticle($magazineID: Int!, $marketID: Int!, $placedPageID: Int!, $productID: Int!) {
					copyDataFromLinktArticle(magazineID: $magazineID, marketID: $marketID, placedPageID: $placedPageID, productID: $productID) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineID: magazineID,
				marketID: marketID,
				placedPageID: placedPageID,
				productID: productID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.copyDataFromLinktArticle) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.copyDataFromLinktArticle, null];
	} catch (error) {
		return [null, error];
	}
}

async function creatCustomField(customField: CustomFieldInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation creatCustomField($customField: CustomFieldInput!) {
					creatCustomField(customField: $customField) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								customField: customField
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.creatCustomField) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.creatCustomField, null];
	} catch (error) {
		return [null, error];
	}
}

async function createApiKey(apiKey: ApiKeyInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createApiKey($apiKey: ApiKeyInput!) {
					createApiKey(apiKey: $apiKey) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								apiKey: apiKey
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createApiKey) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createApiKey, null];
	} catch (error) {
		return [null, error];
	}
}

async function createArtikelNumber(articleNumber: string, purchaserId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createArtikelNumber($articleNumber: String!, $purchaserId: Int!) {
					createArtikelNumber(articleNumber: $articleNumber, purchaserId: $purchaserId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								articleNumber: articleNumber,
				purchaserId: purchaserId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createArtikelNumber) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createArtikelNumber, null];
	} catch (error) {
		return [null, error];
	}
}

async function createFormular(formular: FormularInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createFormular($formular: FormularInput!) {
					createFormular(formular: $formular) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								formular: formular
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createFormular) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createFormular, null];
	} catch (error) {
		return [null, error];
	}
}

async function createInDesignTemplate(templateType: string, categoryId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createInDesignTemplate($templateType: String!, $categoryId: Int!) {
					createInDesignTemplate(templateType: $templateType, categoryId: $categoryId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								templateType: templateType,
				categoryId: categoryId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createInDesignTemplate) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createInDesignTemplate, null];
	} catch (error) {
		return [null, error];
	}
}

async function createInDesignTemplateCategory(type: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createInDesignTemplateCategory($type: String!) {
					createInDesignTemplateCategory(type: $type) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								type: type
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createInDesignTemplateCategory) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createInDesignTemplateCategory, null];
	} catch (error) {
		return [null, error];
	}
}

async function createInDesignTemplateVariant(productTemplateId: number, productId: number, name: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createInDesignTemplateVariant($productTemplateId: Int!, $productId: Int!, $name: String!) {
					createInDesignTemplateVariant(productTemplateId: $productTemplateId, productId: $productId, name: $name) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								productTemplateId: productTemplateId,
				productId: productId,
				name: name
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createInDesignTemplateVariant) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createInDesignTemplateVariant, null];
	} catch (error) {
		return [null, error];
	}
}

async function createMagazine(magazine: MagazineInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createMagazine($magazine: MagazineInput!) {
					createMagazine(magazine: $magazine) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazine: magazine
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createMagazine) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createMagazine, null];
	} catch (error) {
		return [null, error];
	}
}

async function createMagazineType(magazineType: MarketTypeInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createMagazineType($magazineType: MarketTypeInput!) {
					createMagazineType(magazineType: $magazineType) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineType: magazineType
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createMagazineType) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createMagazineType, null];
	} catch (error) {
		return [null, error];
	}
}

async function createMarket(market: CreateMarketInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createMarket($market: CreateMarketInput!) {
					createMarket(market: $market) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								market: market
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createMarket) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createMarket, null];
	} catch (error) {
		return [null, error];
	}
}

async function createNewField(field: FormFieldInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createNewField($field: FormFieldInput!) {
					createNewField(field: $field) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								field: field
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createNewField) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createNewField, null];
	} catch (error) {
		return [null, error];
	}
}

async function createOrUpdateRule(rule: RuleInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createOrUpdateRule($rule: RuleInput!) {
					createOrUpdateRule(rule: $rule) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								rule: rule
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createOrUpdateRule) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createOrUpdateRule, null];
	} catch (error) {
		return [null, error];
	}
}

async function createPage(page: AdPageInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createPage($page: AdPageInput!) {
					createPage(page: $page) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								page: page
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function createProduct(product: ArticleInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createProduct($product: ArticleInput!) {
					createProduct(product: $product) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								product: product
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createProduct) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createProduct, null];
	} catch (error) {
		return [null, error];
	}
}

async function createProject(project: ProjectInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createProject($project: ProjectInput!) {
					createProject(project: $project) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								project: project
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createProject) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createProject, null];
	} catch (error) {
		return [null, error];
	}
}

async function createStatement(id: number, name: string, statement: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createStatement($id: Int!, $name: String!, $statement: String!) {
					createStatement(id: $id, name: $name, statement: $statement) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								id: id,
				name: name,
				statement: statement
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createStatement) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createStatement, null];
	} catch (error) {
		return [null, error];
	}
}

async function createTeam(team: TeamInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createTeam($team: TeamInput!) {
					createTeam(team: $team) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								team: team
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createTeam) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createTeam, null];
	} catch (error) {
		return [null, error];
	}
}

async function createTimeTravelPoint(pageId: number, title: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createTimeTravelPoint($pageId: Int!, $title: String!) {
					createTimeTravelPoint(pageId: $pageId, title: $title) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				title: title
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createTimeTravelPoint) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createTimeTravelPoint, null];
	} catch (error) {
		return [null, error];
	}
}

async function createUser(user: UserInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation createUser($user: UserInput!) {
					createUser(user: $user) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								user: user
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.createUser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.createUser, null];
	} catch (error) {
		return [null, error];
	}
}

async function debug(): Promise<[Debug | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query debug {
					debug {
						message 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.debug) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.debug, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteAllClipboardTaps(): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteAllClipboardTaps {
					deleteAllClipboardTaps {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteAllClipboardTaps) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteAllClipboardTaps, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteApiKey(id: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteApiKey($id: Int!) {
					deleteApiKey(id: $id) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								id: id
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteApiKey) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteApiKey, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteArticle(type: string, isVirtual: boolean, magazinId: number, pageId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteArticle($type: String!, $isVirtual: Boolean!, $magazinId: Int!, $pageId: Int!) {
					deleteArticle(type: $type, isVirtual: $isVirtual, magazinId: $magazinId, pageId: $pageId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								type: type,
				isVirtual: isVirtual,
				magazinId: magazinId,
				pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteArticle) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteArticle, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteArticleFromAllMarkets(magazineId: number, pagePosition: number, productId: number, marketIds: number[]): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteArticleFromAllMarkets($magazineId: Int!, $pagePosition: Int!, $productId: Int!, $marketIds: [Int!]!) {
					deleteArticleFromAllMarkets(magazineId: $magazineId, pagePosition: $pagePosition, productId: $productId, marketIds: $marketIds) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition,
				productId: productId,
				marketIds: marketIds
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteArticleFromAllMarkets) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteArticleFromAllMarkets, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteClipboard(clipboardID: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteClipboard($clipboardID: Int!) {
					deleteClipboard(clipboardID: $clipboardID) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								clipboardID: clipboardID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteClipboard) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteClipboard, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteFormular(formularID: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteFormular($formularID: Int!) {
					deleteFormular(formularID: $formularID) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								formularID: formularID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteFormular) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteFormular, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteInDesignTemplate(templateId: number, type: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteInDesignTemplate($templateId: Int!, $type: String!) {
					deleteInDesignTemplate(templateId: $templateId, type: $type) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								templateId: templateId,
				type: type
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteInDesignTemplate) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteInDesignTemplate, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteInDesignTemplateCategory(categoryId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteInDesignTemplateCategory($categoryId: Int!) {
					deleteInDesignTemplateCategory(categoryId: $categoryId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								categoryId: categoryId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteInDesignTemplateCategory) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteInDesignTemplateCategory, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteMagazine(magazineId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteMagazine($magazineId: Int!) {
					deleteMagazine(magazineId: $magazineId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineId: magazineId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteMagazine) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteMagazine, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteMagazineType(magazineTypeId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteMagazineType($magazineTypeId: Int!) {
					deleteMagazineType(magazineTypeId: $magazineTypeId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineTypeId: magazineTypeId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteMagazineType) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteMagazineType, null];
	} catch (error) {
		return [null, error];
	}
}

async function deletePage(pageId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deletePage($pageId: Int!) {
					deletePage(pageId: $pageId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deletePage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deletePage, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteProductCustomField(productFieldId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteProductCustomField($productFieldId: Int!) {
					deleteProductCustomField(productFieldId: $productFieldId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								productFieldId: productFieldId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteProductCustomField) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteProductCustomField, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteProductFromPage(pageId: number, articleNumber: string, productId: number, virtualId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query deleteProductFromPage($pageId: Int!, $articleNumber: String!, $productId: Int!, $virtualId: Int!) {
					deleteProductFromPage(pageId: $pageId, articleNumber: $articleNumber, productId: $productId, virtualId: $virtualId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				articleNumber: articleNumber,
				productId: productId,
				virtualId: virtualId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteProductFromPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteProductFromPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteProject(projectId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteProject($projectId: Int!) {
					deleteProject(projectId: $projectId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								projectId: projectId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteProject) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteProject, null];
	} catch (error) {
		return [null, error];
	}
}

async function deletePurchaser(purchaserId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deletePurchaser($purchaserId: Int!) {
					deletePurchaser(purchaserId: $purchaserId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								purchaserId: purchaserId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deletePurchaser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deletePurchaser, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteRule(ruleId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteRule($ruleId: Int!) {
					deleteRule(ruleId: $ruleId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								ruleId: ruleId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteRule) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteRule, null];
	} catch (error) {
		return [null, error];
	}
}

async function deleteUser(userId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation deleteUser($userId: Int!) {
					deleteUser(userId: $userId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								userId: userId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.deleteUser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.deleteUser, null];
	} catch (error) {
		return [null, error];
	}
}

async function editBaseArticle(baseArticle: BaseArticleInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editBaseArticle($baseArticle: BaseArticleInput!) {
					editBaseArticle(baseArticle: $baseArticle) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								baseArticle: baseArticle
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editBaseArticle) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editBaseArticle, null];
	} catch (error) {
		return [null, error];
	}
}

async function editClipboard(clipboard: EditClipboardInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editClipboard($clipboard: EditClipboardInput!) {
					editClipboard(clipboard: $clipboard) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								clipboard: clipboard
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editClipboard) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editClipboard, null];
	} catch (error) {
		return [null, error];
	}
}

async function editFromField(forms: FormInputs[], header: FormHeaderInput[], lists: FormListInput[], listsMarket: FormListMarketInput[], attribute: AttributeInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editFromField($forms: [FormInputs]!, $header: [FormHeaderInput]!, $lists: [FormListInput]!, $listsMarket: [FormListMarketInput]!, $attribute: AttributeInput) {
					editFromField(forms: $forms, header: $header, lists: $lists, listsMarket: $listsMarket, attribute: $attribute) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								forms: forms,
				header: header,
				lists: lists,
				listsMarket: listsMarket,
				attribute: attribute
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editFromField) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editFromField, null];
	} catch (error) {
		return [null, error];
	}
}

async function editGridForPage(pageId: number, grid: GridInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editGridForPage($pageId: Int!, $grid: GridInput!) {
					editGridForPage(pageId: $pageId, grid: $grid) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				grid: grid
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editGridForPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editGridForPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function editGridForTemplate(templateId: number, grid: GridInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editGridForTemplate($templateId: Int!, $grid: GridInput!) {
					editGridForTemplate(templateId: $templateId, grid: $grid) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								templateId: templateId,
				grid: grid
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editGridForTemplate) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editGridForTemplate, null];
	} catch (error) {
		return [null, error];
	}
}

async function editImage(image: ImageInputEdit): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editImage($image: ImageInputEdit!) {
					editImage(image: $image) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								image: image
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editImage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editImage, null];
	} catch (error) {
		return [null, error];
	}
}

async function editImageFavorite(imgID: number, favorite: boolean): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editImageFavorite($imgID: Int!, $favorite: Boolean!) {
					editImageFavorite(imgID: $imgID, favorite: $favorite) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								imgID: imgID,
				favorite: favorite
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editImageFavorite) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editImageFavorite, null];
	} catch (error) {
		return [null, error];
	}
}

async function editImagesClass(imgIDs: number[], classID: number, pictureIDs: number[]): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editImagesClass($imgIDs: [Int!]!, $classID: Int!, $pictureIDs: [Int!]!) {
					editImagesClass(imgIDs: $imgIDs, classID: $classID, pictureIDs: $pictureIDs) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								imgIDs: imgIDs,
				classID: classID,
				pictureIDs: pictureIDs
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editImagesClass) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editImagesClass, null];
	} catch (error) {
		return [null, error];
	}
}

async function editImagesPurchaser(imgIDs: number[], purchaserId: number, productPictureIDs: number[]): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editImagesPurchaser($imgIDs: [Int!]!, $purchaserId: Int!, $productPictureIDs: [Int!]!) {
					editImagesPurchaser(imgIDs: $imgIDs, purchaserId: $purchaserId, productPictureIDs: $productPictureIDs) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								imgIDs: imgIDs,
				purchaserId: purchaserId,
				productPictureIDs: productPictureIDs
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editImagesPurchaser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editImagesPurchaser, null];
	} catch (error) {
		return [null, error];
	}
}

async function editInDesignTemplateInfo(templateInfo: InDesignTemplateInfoInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editInDesignTemplateInfo($templateInfo: InDesignTemplateInfoInput!) {
					editInDesignTemplateInfo(templateInfo: $templateInfo) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								templateInfo: templateInfo
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editInDesignTemplateInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editInDesignTemplateInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function editMagazine(magazine: MagazineInputValue): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editMagazine($magazine: MagazineInputValue!) {
					editMagazine(magazine: $magazine) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazine: magazine
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editMagazine) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editMagazine, null];
	} catch (error) {
		return [null, error];
	}
}

async function editMagazineType(magazineType: MagazineTypeInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editMagazineType($magazineType: MagazineTypeInput!) {
					editMagazineType(magazineType: $magazineType) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								magazineType: magazineType
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editMagazineType) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editMagazineType, null];
	} catch (error) {
		return [null, error];
	}
}

async function editMarket(market: MarketInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editMarket($market: MarketInput!) {
					editMarket(market: $market) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								market: market
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editMarket) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editMarket, null];
	} catch (error) {
		return [null, error];
	}
}

async function editOnSetDelete(image: Image): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editOnSetDelete($image: Image!) {
					editOnSetDelete(image: $image) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								image: image
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editOnSetDelete) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editOnSetDelete, null];
	} catch (error) {
		return [null, error];
	}
}

async function editPage(page: PagePosition[]): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editPage($page: [PagePosition!]!) {
					editPage(page: $page) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								page: page
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function editPageName(pageId: number, pageName: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editPageName($pageId: Int!, $pageName: String!) {
					editPageName(pageId: $pageId, pageName: $pageName) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				pageName: pageName
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editPageName) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editPageName, null];
	} catch (error) {
		return [null, error];
	}
}

async function editPageTeams(teamPage: PageTeamInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editPageTeams($teamPage: PageTeamInput!) {
					editPageTeams(teamPage: $teamPage) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								teamPage: teamPage
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editPageTeams) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editPageTeams, null];
	} catch (error) {
		return [null, error];
	}
}

async function editPageTemplate(pageTemplateId: number, magazineId: number, marketIds: number[], pageId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editPageTemplate($pageTemplateId: Int!, $magazineId: Int!, $marketIds: [Int!]!, $pageId: Int!) {
					editPageTemplate(pageTemplateId: $pageTemplateId, magazineId: $magazineId, marketIds: $marketIds, pageId: $pageId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageTemplateId: pageTemplateId,
				magazineId: magazineId,
				marketIds: marketIds,
				pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editPageTemplate) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editPageTemplate, null];
	} catch (error) {
		return [null, error];
	}
}

async function editPageTemplateInfo(pageTemplate: PageTemplateInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editPageTemplateInfo($pageTemplate: PageTemplateInput!) {
					editPageTemplateInfo(pageTemplate: $pageTemplate) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageTemplate: pageTemplate
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editPageTemplateInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editPageTemplateInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function editProductCustomField(productField: CustomFieldInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editProductCustomField($productField: CustomFieldInput!) {
					editProductCustomField(productField: $productField) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								productField: productField
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editProductCustomField) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editProductCustomField, null];
	} catch (error) {
		return [null, error];
	}
}

async function editProject(project: ProjectInputValue): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editProject($project: ProjectInputValue!) {
					editProject(project: $project) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								project: project
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editProject) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editProject, null];
	} catch (error) {
		return [null, error];
	}
}

async function editTeam(team: TeamInputEdit): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editTeam($team: TeamInputEdit!) {
					editTeam(team: $team) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								team: team
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editTeam) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editTeam, null];
	} catch (error) {
		return [null, error];
	}
}

async function editUser(user: UserInputEdit): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editUser($user: UserInputEdit!) {
					editUser(user: $user) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								user: user
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editUser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editUser, null];
	} catch (error) {
		return [null, error];
	}
}

async function editUserInformation(user: UserInputInformation): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editUserInformation($user: UserInputInformation!) {
					editUserInformation(user: $user) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								user: user
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editUserInformation) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editUserInformation, null];
	} catch (error) {
		return [null, error];
	}
}

async function editUserPassword(userId: number, password: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation editUserPassword($userId: Int!, $password: String!) {
					editUserPassword(userId: $userId, password: $password) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								userId: userId,
				password: password
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.editUserPassword) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.editUserPassword, null];
	} catch (error) {
		return [null, error];
	}
}

async function excelImport(magazineID: number, pagePositions: number[], purchaserId: number, ignorePurchaser: boolean, data: ExcelDataInput[], goalPurchaserId: number): Promise<[Report | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation excelImport($magazineID: Int!, $pagePositions: [Int!]!, $purchaserId: Int!, $ignorePurchaser: Boolean!, $data: [ExcelDataInput]!, $goalPurchaserId: Int!) {
					excelImport(magazineID: $magazineID, pagePositions: $pagePositions, purchaserId: $purchaserId, ignorePurchaser: $ignorePurchaser, data: $data, goalPurchaserId: $goalPurchaserId) {
						jopId 
						success 
						errors {
							code 
							message 
							data {
								key 
								value 
							}
						}
						messages {
							code 
							message 
							data {
								key 
								value 
							}
						}
					}
				}
				`),
			variables: {
								magazineID: magazineID,
				pagePositions: pagePositions,
				purchaserId: purchaserId,
				ignorePurchaser: ignorePurchaser,
				data: data,
				goalPurchaserId: goalPurchaserId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.excelImport) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.excelImport, null];
	} catch (error) {
		return [null, error];
	}
}

async function executeSqlCommand(command: string): Promise<[TableData | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation executeSqlCommand($command: String!) {
					executeSqlCommand(command: $command) {
						columns 
						rows 
						totalCount 
					}
				}
				`),
			variables: {
								command: command
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.executeSqlCommand) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.executeSqlCommand, null];
	} catch (error) {
		return [null, error];
	}
}

async function exportImages(exportImages: ExportImages[], updateMainArticle: boolean): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation exportImages($exportImages: [ExportImages!], $updateMainArticle: Boolean!) {
					exportImages(exportImages: $exportImages, updateMainArticle: $updateMainArticle) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								exportImages: exportImages,
				updateMainArticle: updateMainArticle
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.exportImages) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.exportImages, null];
	} catch (error) {
		return [null, error];
	}
}

async function getAccordionIndex(magazineId: number, pagePosition: number, marktId: number, articleNumber: string): Promise<[number | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getAccordionIndex($magazineId: Int!, $pagePosition: Int!, $marktId: Int!, $articleNumber: String!) {
					getAccordionIndex(magazineId: $magazineId, pagePosition: $pagePosition, marktId: $marktId, articleNumber: $articleNumber) 
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition,
				marktId: marktId,
				articleNumber: articleNumber
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getAccordionIndex) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getAccordionIndex, null];
	} catch (error) {
		return [null, error];
	}
}

async function getAllMarkets(): Promise<[Market[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getAllMarkets {
					getAllMarkets {
						marketId 
						name 
						description 
						isActive 
						sapMarketName 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getAllMarkets) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getAllMarkets, null];
	} catch (error) {
		return [null, error];
	}
}

async function getAllUser(): Promise<[User[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getAllUser {
					getAllUser {
						userId 
						userName 
						lastUpdateTimestamp 
						language 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getAllUser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getAllUser, null];
	} catch (error) {
		return [null, error];
	}
}

async function getApiKey(id: number): Promise<[ApiKey | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getApiKey($id: Int!) {
					getApiKey(id: $id) {
						id 
						name 
						description 
						key 
						createdAt 
					}
				}
				`),
			variables: {
								id: id
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getApiKey) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getApiKey, null];
	} catch (error) {
		return [null, error];
	}
}

async function getApiKeys(): Promise<[ApiKey[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getApiKeys {
					getApiKeys {
						id 
						name 
						description 
						key 
						createdAt 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getApiKeys) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getApiKeys, null];
	} catch (error) {
		return [null, error];
	}
}

async function getArticleFromMarkets(articleNumber: string, pageId: number, magazineId: number, pagePosition: string, virtualId: number): Promise<[ArticleNumber[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getArticleFromMarkets($articleNumber: String!, $pageId: Int!, $magazineId: Int!, $pagePosition: String!, $virtualId: Int!) {
					getArticleFromMarkets(articleNumber: $articleNumber, pageId: $pageId, magazineId: $magazineId, pagePosition: $pagePosition, virtualId: $virtualId) {
						marketId 
						position 
						size 
					}
				}
				`),
			variables: {
								articleNumber: articleNumber,
				pageId: pageId,
				magazineId: magazineId,
				pagePosition: pagePosition,
				virtualId: virtualId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getArticleFromMarkets) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getArticleFromMarkets, null];
	} catch (error) {
		return [null, error];
	}
}

async function getArticleInformation(articleNumber: string, magazineID: number, marketID: number): Promise<[ArticleData | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getArticleInformation($articleNumber: String!, $magazineID: Int!, $marketID: Int!) {
					getArticleInformation(articleNumber: $articleNumber, magazineID: $magazineID, marketID: $marketID) {
						exists 
						pageId 
						productId 
						purchaserId 
						templateId 
						fields {
							productCustomFieldId 
							productId 
							field 
							value 
						}
						picture {
							productJoinProductPictureId 
							productPictureId 
							teamId 
							isActive 
							originalFilePath 
							previewSmall 
							previewMedium 
							previewLarge 
							position 
							markedForDeletion 
							isDefault 
							name 
							dateTimeCreated 
							dateTimeUpdated 
							delete 
						}
						logo {
							productJoinProductLogoId 
							productLogoId 
							teamId 
							isActive 
							originalFilePath 
							previewSmall 
							previewMedium 
							previewLarge 
							position 
							markedForDeletion 
							name 
							dateTimeCreated 
							dateTimeUpdated 
							delete 
						}
					}
				}
				`),
			variables: {
								articleNumber: articleNumber,
				magazineID: magazineID,
				marketID: marketID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getArticleInformation) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getArticleInformation, null];
	} catch (error) {
		return [null, error];
	}
}

async function getArticleNumbers(articleNumber: string): Promise<[Article[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getArticleNumbers($articleNumber: String!) {
					getArticleNumbers(articleNumber: $articleNumber) {
						articleId 
						articleNumber 
						productID 
					}
				}
				`),
			variables: {
								articleNumber: articleNumber
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getArticleNumbers) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getArticleNumbers, null];
	} catch (error) {
		return [null, error];
	}
}

async function getArticleNumbersByPageId(pageId: number): Promise<[ArticleInformation[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getArticleNumbersByPageId($pageId: Int!) {
					getArticleNumbersByPageId(pageId: $pageId) {
						articleNumbers 
						articlePurchaser {
							id 
							name 
							teamPosition 
							teamIcon 
							color 
						}
						purchaser {
							id 
							name 
							teamPosition 
							teamIcon 
							color 
						}
					}
				}
				`),
			variables: {
								pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getArticleNumbersByPageId) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getArticleNumbersByPageId, null];
	} catch (error) {
		return [null, error];
	}
}

async function getArticleTemplateGroups(): Promise<[ArticleTemplateGroup[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getArticleTemplateGroups {
					getArticleTemplateGroups {
						idArticleTemplateGroup 
						name 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getArticleTemplateGroups) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getArticleTemplateGroups, null];
	} catch (error) {
		return [null, error];
	}
}

async function getAsset(searchTerm: string, count: number, option: number, searchType: string, showOnlyImagesWithNoArticleNumber: boolean): Promise<[AssetSearchResult[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getAsset($searchTerm: String, $count: Int!, $option: Int!, $searchType: String!, $showOnlyImagesWithNoArticleNumber: Boolean!) {
					getAsset(searchTerm: $searchTerm, count: $count, option: $option, searchType: $searchType, showOnlyImagesWithNoArticleNumber: $showOnlyImagesWithNoArticleNumber) {
						image {
							imgLocID 
							imgLocProductName 
							imgLocOrgFilepath 
							imgLocOrgFilename 
							imgLocFileModDate 
							imgLocMarkedForDeletion 
							imgLocGo2pict 
							IMGLocGo2pictClass 
							imgLocMainFileSize 
							imgLocArticleNumber 
							imgLocNewFilepath 
							imgLocNewFilename 
							imgLocGo2pictIDPicture 
							imgLocGo2pictIDProductPic 
							imgLocImagWithOrg 
							imgLocImagHightOrg 
							imgLocImagDpiOrg 
							isInFavorite 
							pictureLink 
							purchaserID 
						}
						numberOfImages 
					}
				}
				`),
			variables: {
								searchTerm: searchTerm,
				count: count,
				option: option,
				searchType: searchType,
				showOnlyImagesWithNoArticleNumber: showOnlyImagesWithNoArticleNumber
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getAsset) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getAsset, null];
	} catch (error) {
		return [null, error];
	}
}

async function getBaseArticle(productId: number): Promise<[BaseArticle | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getBaseArticle($productId: Int!) {
					getBaseArticle(productId: $productId) {
						articleNumber 
						productId 
						teamId 
						fields {
							fieldId 
							fieldName 
							fieldValue 
						}
					}
				}
				`),
			variables: {
								productId: productId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getBaseArticle) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getBaseArticle, null];
	} catch (error) {
		return [null, error];
	}
}

async function getDataFromTable(tableName: string, limit: number, offset: number, filters: ColumnFilterInput[]): Promise<[TableData | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getDataFromTable($tableName: String!, $limit: Int!, $offset: Int!, $filters: [ColumnFilterInput!]) {
					getDataFromTable(tableName: $tableName, limit: $limit, offset: $offset, filters: $filters) {
						columns 
						rows 
						totalCount 
					}
				}
				`),
			variables: {
								tableName: tableName,
				limit: limit,
				offset: offset,
				filters: filters
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getDataFromTable) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getDataFromTable, null];
	} catch (error) {
		return [null, error];
	}
}

async function getFieldLabel(): Promise<[FieldLabel[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getFieldLabel {
					getFieldLabel {
						id 
						label 
						field 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getFieldLabel) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getFieldLabel, null];
	} catch (error) {
		return [null, error];
	}
}

async function getFormular(formularID: number): Promise<[Formular[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getFormular($formularID: Int!) {
					getFormular(formularID: $formularID) {
						id 
						groupID 
						formularType 
						label 
						value 
						fieldValue 
						image 
						readOnly 
						field 
					}
				}
				`),
			variables: {
								formularID: formularID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getFormular) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getFormular, null];
	} catch (error) {
		return [null, error];
	}
}

async function getFormularInfos(): Promise<[Formular[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getFormularInfos {
					getFormularInfos {
						id 
						groupID 
						formularType 
						label 
						value 
						fieldValue 
						image 
						readOnly 
						field 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getFormularInfos) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getFormularInfos, null];
	} catch (error) {
		return [null, error];
	}
}

async function getFormularInfosGroup(): Promise<[FormularGroup[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getFormularInfosGroup {
					getFormularInfosGroup {
						id 
						name 
						groupType 
						traderID 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getFormularInfosGroup) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getFormularInfosGroup, null];
	} catch (error) {
		return [null, error];
	}
}

async function getFormularName(productFormId: number): Promise<[FormularName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getFormularName($productFormId: Int!) {
					getFormularName(productFormId: $productFormId) {
						idForm 
						name 
						magazineType 
					}
				}
				`),
			variables: {
								productFormId: productFormId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getFormularName) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getFormularName, null];
	} catch (error) {
		return [null, error];
	}
}

async function getFormularNames(): Promise<[FormularName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getFormularNames {
					getFormularNames {
						idForm 
						name 
						magazineType 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getFormularNames) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getFormularNames, null];
	} catch (error) {
		return [null, error];
	}
}

async function getFormularValue(formularID: number, productId: number): Promise<[Formular[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getFormularValue($formularID: Int!, $productId: Int!) {
					getFormularValue(formularID: $formularID, productId: $productId) {
						id 
						groupID 
						formularType 
						label 
						value 
						fieldValue 
						image 
						readOnly 
						field 
					}
				}
				`),
			variables: {
								formularID: formularID,
				productId: productId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getFormularValue) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getFormularValue, null];
	} catch (error) {
		return [null, error];
	}
}

async function getGridByPage(pageId: number): Promise<[Grid | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getGridByPage($pageId: Int!) {
					getGridByPage(pageId: $pageId) {
						pageTemplateName 
						pageHeight 
						pageWidth 
						marginTop 
						marginBottom 
						marginLeft 
						marginRight 
						cutTop 
						cutBottom 
						cutLeft 
						cutRight 
						columns 
						rows 
						columnGap 
						rowGap 
						userPurchaseIds 
						placeholders {
							x 
							y 
							width 
							height 
							position 
							virtualId 
							purchaser {
								id 
								name 
								teamPosition 
								teamIcon 
								color 
							}
							article {
								articleNumber 
								virtualId 
							}
							originalPlaceholdersIndex 
						}
					}
				}
				`),
			variables: {
								pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getGridByPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getGridByPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function getGridByTemplateId(pageTemplateId: number): Promise<[Grid | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getGridByTemplateId($pageTemplateId: Int!) {
					getGridByTemplateId(pageTemplateId: $pageTemplateId) {
						pageTemplateName 
						pageHeight 
						pageWidth 
						marginTop 
						marginBottom 
						marginLeft 
						marginRight 
						cutTop 
						cutBottom 
						cutLeft 
						cutRight 
						columns 
						rows 
						columnGap 
						rowGap 
						userPurchaseIds 
						placeholders {
							x 
							y 
							width 
							height 
							position 
							virtualId 
							purchaser {
								id 
								name 
								teamPosition 
								teamIcon 
								color 
							}
							article {
								articleNumber 
								virtualId 
							}
							originalPlaceholdersIndex 
						}
					}
				}
				`),
			variables: {
								pageTemplateId: pageTemplateId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getGridByTemplateId) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getGridByTemplateId, null];
	} catch (error) {
		return [null, error];
	}
}

async function getImageByPath(imagePath: string): Promise<[ImageData | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getImageByPath($imagePath: String!) {
					getImageByPath(imagePath: $imagePath) {
						imgLocID 
						imgLocProductName 
						imgLocOrgFilepath 
						imgLocOrgFilename 
						imgLocFileModDate 
						imgLocMarkedForDeletion 
						imgLocGo2pict 
						IMGLocGo2pictClass 
						imgLocMainFileSize 
						imgLocArticleNumber 
						imgLocNewFilepath 
						imgLocNewFilename 
						imgLocGo2pictIDPicture 
						imgLocGo2pictIDProductPic 
						imgLocImagWithOrg 
						imgLocImagHightOrg 
						imgLocImagDpiOrg 
						isInFavorite 
						pictureLink 
						purchaserID 
					}
				}
				`),
			variables: {
								imagePath: imagePath
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getImageByPath) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getImageByPath, null];
	} catch (error) {
		return [null, error];
	}
}

async function getImportClass(): Promise<[ImportClass[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getImportClass {
					getImportClass {
						idPictureClass 
						pictureClass 
						position 
						useFilter 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getImportClass) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getImportClass, null];
	} catch (error) {
		return [null, error];
	}
}

async function getInDesignRules(): Promise<[InDesignRule[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getInDesignRules {
					getInDesignRules {
						id 
						name 
						layout 
						script 
						timestamp 
						userId 
						description 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getInDesignRules) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getInDesignRules, null];
	} catch (error) {
		return [null, error];
	}
}

async function getInDesignTemplateCategories(type: string): Promise<[InDesignTemplateCategory[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getInDesignTemplateCategories($type: String!) {
					getInDesignTemplateCategories(type: $type) {
						id 
						name 
						type 
					}
				}
				`),
			variables: {
								type: type
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getInDesignTemplateCategories) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getInDesignTemplateCategories, null];
	} catch (error) {
		return [null, error];
	}
}

async function getInDesignTemplateInfo(templateType: string, templateId: number): Promise<[InDesignTemplateInfo | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getInDesignTemplateInfo($templateType: String!, $templateId: Int!) {
					getInDesignTemplateInfo(templateType: $templateType, templateId: $templateId) {
						id 
						type 
						name 
						width 
						height 
						magazineTypeId 
						isHidden 
						isDefault 
						defaultForSize 
						defaultForPageSide 
						backupTimestamps 
					}
				}
				`),
			variables: {
								templateType: templateType,
				templateId: templateId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getInDesignTemplateInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getInDesignTemplateInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function getInDesignTemplates(type: string, categoryId: number): Promise<[InDesignTemplate[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getInDesignTemplates($type: String!, $categoryId: Int!) {
					getInDesignTemplates(type: $type, categoryId: $categoryId) {
						id 
						name 
						type 
						exists 
					}
				}
				`),
			variables: {
								type: type,
				categoryId: categoryId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getInDesignTemplates) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getInDesignTemplates, null];
	} catch (error) {
		return [null, error];
	}
}

async function getJop(jopId: number): Promise<[Progress | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getJop($jopId: Int!) {
					getJop(jopId: $jopId) {
						processed 
						status 
						id 
						report {
							jopId 
							success 
							errors {
								code 
								message 
								data {
									key 
									value 
								}
							}
							messages {
								code 
								message 
								data {
									key 
									value 
								}
							}
						}
					}
				}
				`),
			variables: {
								jopId: jopId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getJop) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getJop, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMagazine(magazineId: number): Promise<[Magazine | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMagazine($magazineId: Int!) {
					getMagazine(magazineId: $magazineId) {
						magazineId 
						lock 
						name 
						numberOfPages 
						pages {
							pageId 
							isOnMarket 
							lock 
							projectId 
							marketId 
							magazineId 
							magazinePageCount 
							team {
								id 
								tag 
								name 
								color 
							}
							magazineTypeId 
							magazineTypeName 
							pagePosition 
							name 
							attributes {
								key 
								value 
							}
							products {
								productId 
								articleNumber 
								placeholderId 
								placeholderWidth 
								placeholderHeight 
								placeholderPosition 
								productPosition 
								productCustomFields {
									productCustomFieldId 
									productId 
									field 
									value 
								}
								productTemplate {
									productTemplateId 
									name 
								}
								productTemplateId 
								productTemplateName 
								productPictures {
									productJoinProductPictureId 
									productPictureId 
									teamId 
									isActive 
									originalFilePath 
									previewSmall 
									previewMedium 
									previewLarge 
									position 
									markedForDeletion 
									isDefault 
									name 
									dateTimeCreated 
									dateTimeUpdated 
									delete 
								}
								productLogos {
									productJoinProductLogoId 
									productLogoId 
									teamId 
									isActive 
									originalFilePath 
									previewSmall 
									previewMedium 
									previewLarge 
									position 
									markedForDeletion 
									name 
									dateTimeCreated 
									dateTimeUpdated 
									delete 
								}
								teamIcon 
								isVirtualArticle 
								virtualProjektId 
								virtualMagazineId 
								virtualPagePosition 
								virtualMarketId 
								virtualProjektName 
								virtualMagazineName 
								virtualMarketName 
								virtualOriginalLastChange 
								virtualAccordionIndex 
								teamColor 
								marketIds 
							}
							pageTemplateId 
							hooks 
						}
						magazineType 
						magazineTypeId 
						from 
						to 
						printNumber 
						mmW 
						mmH 
					}
				}
				`),
			variables: {
								magazineId: magazineId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMagazine) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMagazine, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMagazineType(magazineTypeId: number): Promise<[MagazineType | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMagazineType($magazineTypeId: Int!) {
					getMagazineType(magazineTypeId: $magazineTypeId) {
						magazineTypeId 
						magazineType 
						magazineTypeTitle 
						supportMarkets 
					}
				}
				`),
			variables: {
								magazineTypeId: magazineTypeId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMagazineType) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMagazineType, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMagazineTypes(): Promise<[MagazineType[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMagazineTypes {
					getMagazineTypes {
						magazineTypeId 
						magazineType 
						magazineTypeTitle 
						supportMarkets 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMagazineTypes) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMagazineTypes, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMagazinesWithIdAndName(projectID: number): Promise<[IdName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMagazinesWithIdAndName($projectID: Int!) {
					getMagazinesWithIdAndName(projectID: $projectID) {
						id 
						name 
					}
				}
				`),
			variables: {
								projectID: projectID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMagazinesWithIdAndName) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMagazinesWithIdAndName, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMarket(marketId: number): Promise<[Market | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMarket($marketId: Int!) {
					getMarket(marketId: $marketId) {
						marketId 
						name 
						description 
						isActive 
						sapMarketName 
					}
				}
				`),
			variables: {
								marketId: marketId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMarket) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMarket, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMarketCustomField(): Promise<[MarketCustomField[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMarketCustomField {
					getMarketCustomField {
						idCustomField 
						fieldValue 
						fieldName 
						label 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMarketCustomField) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMarketCustomField, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMarketCustomFieldValues(marketId: number): Promise<[MarketCustomFieldValue[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMarketCustomFieldValues($marketId: Int!) {
					getMarketCustomFieldValues(marketId: $marketId) {
						idCustomFieldValue 
						idCustomField 
						idMarket 
						fieldValue 
						fieldName 
						label 
					}
				}
				`),
			variables: {
								marketId: marketId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMarketCustomFieldValues) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMarketCustomFieldValues, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMarkets(): Promise<[Market[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMarkets {
					getMarkets {
						marketId 
						name 
						description 
						isActive 
						sapMarketName 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMarkets) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMarkets, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMarketsInfo(magazineId: number, pagePosition: number): Promise<[MarketInfo[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMarketsInfo($magazineId: Int!, $pagePosition: Int!) {
					getMarketsInfo(magazineId: $magazineId, pagePosition: $pagePosition) {
						marketId 
						name 
						description 
						isActive 
						templateId 
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMarketsInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMarketsInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMarketsStatus(magazineId: number, pagePosition: number): Promise<[MarketStatus[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMarketsStatus($magazineId: Int!, $pagePosition: Int!) {
					getMarketsStatus(magazineId: $magazineId, pagePosition: $pagePosition) {
						marketId 
						name 
						description 
						isActive 
						isFull 
						sapMarketName 
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMarketsStatus) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMarketsStatus, null];
	} catch (error) {
		return [null, error];
	}
}

async function getMarketsWithIdAndName(magazineID: number): Promise<[IdName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getMarketsWithIdAndName($magazineID: Int!) {
					getMarketsWithIdAndName(magazineID: $magazineID) {
						id 
						name 
					}
				}
				`),
			variables: {
								magazineID: magazineID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getMarketsWithIdAndName) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getMarketsWithIdAndName, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPackages(): Promise<[Package[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPackages {
					getPackages {
						name 
						description 
						version 
						company 
						author 
						email 
						website 
						license 
						actions {
							title 
							script 
						}
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPackages) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPackages, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPage(magazineId: number, pagePosition: number, marketId: number): Promise<[Page | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPage($magazineId: Int!, $pagePosition: Int!, $marketId: Int!) {
					getPage(magazineId: $magazineId, pagePosition: $pagePosition, marketId: $marketId) {
						pageId 
						isOnMarket 
						lock 
						projectId 
						marketId 
						magazineId 
						magazinePageCount 
						team {
							id 
							tag 
							name 
							color 
						}
						magazineTypeId 
						magazineTypeName 
						pagePosition 
						name 
						attributes {
							key 
							value 
						}
						products {
							productId 
							articleNumber 
							placeholderId 
							placeholderWidth 
							placeholderHeight 
							placeholderPosition 
							productPosition 
							productCustomFields {
								productCustomFieldId 
								productId 
								field 
								value 
							}
							productTemplate {
								productTemplateId 
								name 
							}
							productTemplateId 
							productTemplateName 
							productPictures {
								productJoinProductPictureId 
								productPictureId 
								teamId 
								isActive 
								originalFilePath 
								previewSmall 
								previewMedium 
								previewLarge 
								position 
								markedForDeletion 
								isDefault 
								name 
								dateTimeCreated 
								dateTimeUpdated 
								delete 
							}
							productLogos {
								productJoinProductLogoId 
								productLogoId 
								teamId 
								isActive 
								originalFilePath 
								previewSmall 
								previewMedium 
								previewLarge 
								position 
								markedForDeletion 
								name 
								dateTimeCreated 
								dateTimeUpdated 
								delete 
							}
							teamIcon 
							isVirtualArticle 
							virtualProjektId 
							virtualMagazineId 
							virtualPagePosition 
							virtualMarketId 
							virtualProjektName 
							virtualMagazineName 
							virtualMarketName 
							virtualOriginalLastChange 
							virtualAccordionIndex 
							teamColor 
							marketIds 
						}
						pageTemplateId 
						hooks 
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition,
				marketId: marketId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPageInfo(pageId: number): Promise<[PageInfo | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPageInfo($pageId: Int!) {
					getPageInfo(pageId: $pageId) {
						projectId 
						projectName 
						magazineId 
						magazineName 
						pageId 
						pageName 
						pagePosition 
						marketId 
						marketName 
					}
				}
				`),
			variables: {
								pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPageInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPageInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPageList(magazineId: number, pagePosition: number, marketId: number): Promise<[PageList | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPageList($magazineId: Int!, $pagePosition: Int!, $marketId: Int!) {
					getPageList(magazineId: $magazineId, pagePosition: $pagePosition, marketId: $marketId) {
						markets {
							marketId 
							marketName 
							isActive 
							marketDescription 
							pageId 
							marketTeams {
								teamId 
								placeholderUsed 
								placeholderTotal 
							}
						}
						products {
							articleNumber 
							productId 
							teamId 
							placedOnTeamId 
							teamIcon 
							teamColor 
							markets {
								marketId 
								customFields {
									productCustomFieldId 
									productId 
									field 
									originalValue 
									value 
								}
							}
						}
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				pagePosition: pagePosition,
				marketId: marketId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPageList) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPageList, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPageTemplateGroups(magazinId: number): Promise<[PageTemplateGroup[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPageTemplateGroups($magazinId: Int!) {
					getPageTemplateGroups(magazinId: $magazinId) {
						idPageTemplateGroup 
						name 
					}
				}
				`),
			variables: {
								magazinId: magazinId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPageTemplateGroups) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPageTemplateGroups, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPageTemplates(articleTemplateGroupId: number): Promise<[PageTemplate[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPageTemplates($articleTemplateGroupId: Int!) {
					getPageTemplates(articleTemplateGroupId: $articleTemplateGroupId) {
						pageTemplateId 
						name 
						groupId 
					}
				}
				`),
			variables: {
								articleTemplateGroupId: articleTemplateGroupId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPageTemplates) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPageTemplates, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPageTemplatesByFilter(pageTemplateFilter: PageTemplateFilter): Promise<[PageTemplate[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPageTemplatesByFilter($pageTemplateFilter: PageTemplateFilter) {
					getPageTemplatesByFilter(pageTemplateFilter: $pageTemplateFilter) {
						pageTemplateId 
						name 
						groupId 
					}
				}
				`),
			variables: {
								pageTemplateFilter: pageTemplateFilter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPageTemplatesByFilter) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPageTemplatesByFilter, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPageWithIdAndNameBy(magazineID: number, marketID: number, pagePosition: number): Promise<[IdName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPageWithIdAndNameBy($magazineID: Int!, $marketID: Int!, $pagePosition: Int!) {
					getPageWithIdAndNameBy(magazineID: $magazineID, marketID: $marketID, pagePosition: $pagePosition) {
						id 
						name 
					}
				}
				`),
			variables: {
								magazineID: magazineID,
				marketID: marketID,
				pagePosition: pagePosition
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPageWithIdAndNameBy) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPageWithIdAndNameBy, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPagesByMarketID(marketID: number, magazineID: number): Promise<[Page[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPagesByMarketID($marketID: Int!, $magazineID: Int!) {
					getPagesByMarketID(marketID: $marketID, magazineID: $magazineID) {
						pageId 
						isOnMarket 
						lock 
						projectId 
						marketId 
						magazineId 
						magazinePageCount 
						team {
							id 
							tag 
							name 
							color 
						}
						magazineTypeId 
						magazineTypeName 
						pagePosition 
						name 
						attributes {
							key 
							value 
						}
						products {
							productId 
							articleNumber 
							placeholderId 
							placeholderWidth 
							placeholderHeight 
							placeholderPosition 
							productPosition 
							productCustomFields {
								productCustomFieldId 
								productId 
								field 
								value 
							}
							productTemplate {
								productTemplateId 
								name 
							}
							productTemplateId 
							productTemplateName 
							productPictures {
								productJoinProductPictureId 
								productPictureId 
								teamId 
								isActive 
								originalFilePath 
								previewSmall 
								previewMedium 
								previewLarge 
								position 
								markedForDeletion 
								isDefault 
								name 
								dateTimeCreated 
								dateTimeUpdated 
								delete 
							}
							productLogos {
								productJoinProductLogoId 
								productLogoId 
								teamId 
								isActive 
								originalFilePath 
								previewSmall 
								previewMedium 
								previewLarge 
								position 
								markedForDeletion 
								name 
								dateTimeCreated 
								dateTimeUpdated 
								delete 
							}
							teamIcon 
							isVirtualArticle 
							virtualProjektId 
							virtualMagazineId 
							virtualPagePosition 
							virtualMarketId 
							virtualProjektName 
							virtualMagazineName 
							virtualMarketName 
							virtualOriginalLastChange 
							virtualAccordionIndex 
							teamColor 
							marketIds 
						}
						pageTemplateId 
						hooks 
					}
				}
				`),
			variables: {
								marketID: marketID,
				magazineID: magazineID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPagesByMarketID) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPagesByMarketID, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPagesWithIdAndName(magazineID: number): Promise<[IdName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPagesWithIdAndName($magazineID: Int!) {
					getPagesWithIdAndName(magazineID: $magazineID) {
						id 
						name 
					}
				}
				`),
			variables: {
								magazineID: magazineID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPagesWithIdAndName) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPagesWithIdAndName, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPlaceholdersForMarkets(magazinId: number, pagePosition: number): Promise<[MarketPlaceholders[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPlaceholdersForMarkets($magazinId: Int!, $pagePosition: Int!) {
					getPlaceholdersForMarkets(magazinId: $magazinId, pagePosition: $pagePosition) {
						marketId 
						marketName 
						placeholders {
							isEmpty 
							placeholderId 
							productPosition 
							purchaser {
								id 
								name 
								teamPosition 
								teamIcon 
								color 
							}
						}
					}
				}
				`),
			variables: {
								magazinId: magazinId,
				pagePosition: pagePosition
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPlaceholdersForMarkets) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPlaceholdersForMarkets, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPrintInfo(magazineId: number, fromPage: number, toPage: number, marketIds: number[]): Promise<[PrintInfo | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPrintInfo($magazineId: Int!, $fromPage: Int!, $toPage: Int!, $marketIds: [Int!]!) {
					getPrintInfo(magazineId: $magazineId, fromPage: $fromPage, toPage: $toPage, marketIds: $marketIds) {
						projectName 
						magazineName 
						pages {
							pageId 
							pagePosition 
							marketName 
						}
					}
				}
				`),
			variables: {
								magazineId: magazineId,
				fromPage: fromPage,
				toPage: toPage,
				marketIds: marketIds
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPrintInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPrintInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProductCustomField(productFieldId: number): Promise<[CustomField | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProductCustomField($productFieldId: Int!) {
					getProductCustomField(productFieldId: $productFieldId) {
						idProductCustomField 
						fieldName 
						dontCopy 
						ignoreOnPlaceProduct 
					}
				}
				`),
			variables: {
								productFieldId: productFieldId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProductCustomField) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProductCustomField, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProductCustomFields(): Promise<[CustomField[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProductCustomFields {
					getProductCustomFields {
						idProductCustomField 
						fieldName 
						dontCopy 
						ignoreOnPlaceProduct 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProductCustomFields) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProductCustomFields, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProductFormHeader(idProductForm: number): Promise<[ProductFormHeader[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProductFormHeader($idProductForm: Int!) {
					getProductFormHeader(idProductForm: $idProductForm) {
						idProductFormHeader 
						idProductForm 
						label 
						field 
						size 
					}
				}
				`),
			variables: {
								idProductForm: idProductForm
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProductFormHeader) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProductFormHeader, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProductFormHeaders(): Promise<[ProductFormHeader[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProductFormHeaders {
					getProductFormHeaders {
						idProductFormHeader 
						idProductForm 
						label 
						field 
						size 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProductFormHeaders) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProductFormHeaders, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProductFormList(idProductForm: number): Promise<[ProductFormList[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProductFormList($idProductForm: Int!) {
					getProductFormList(idProductForm: $idProductForm) {
						idProductFormList 
						idProductForm 
						label 
						field 
						size 
						type 
					}
				}
				`),
			variables: {
								idProductForm: idProductForm
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProductFormList) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProductFormList, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProductFormListMarket(idProductForm: number): Promise<[ProductFormListMarket[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProductFormListMarket($idProductForm: Int!) {
					getProductFormListMarket(idProductForm: $idProductForm) {
						idProductFormListMarket 
						idProductForm 
						label 
						field 
						mainSize 
						textSize 
						type 
					}
				}
				`),
			variables: {
								idProductForm: idProductForm
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProductFormListMarket) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProductFormListMarket, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProductsWithIdAndName(magazineID: number, marketID: number, pagePosition: number): Promise<[IdName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProductsWithIdAndName($magazineID: Int!, $marketID: Int!, $pagePosition: Int!) {
					getProductsWithIdAndName(magazineID: $magazineID, marketID: $marketID, pagePosition: $pagePosition) {
						id 
						name 
					}
				}
				`),
			variables: {
								magazineID: magazineID,
				marketID: marketID,
				pagePosition: pagePosition
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProductsWithIdAndName) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProductsWithIdAndName, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProjectsForCurrentUser(): Promise<[UserProject[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProjectsForCurrentUser {
					getProjectsForCurrentUser {
						projectId 
						projectName 
						lock 
						magazines {
							magazineId 
							magazineName 
							lock 
							pages {
								pageId 
								pageName 
								lock 
								pagePosition 
								marketId 
							}
						}
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProjectsForCurrentUser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProjectsForCurrentUser, null];
	} catch (error) {
		return [null, error];
	}
}

async function getProjectsWithIdAndName(): Promise<[IdName[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getProjectsWithIdAndName {
					getProjectsWithIdAndName {
						id 
						name 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getProjectsWithIdAndName) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getProjectsWithIdAndName, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPurchaserByID(teamID: number): Promise<[Purchaser | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPurchaserByID($teamID: Int!) {
					getPurchaserByID(teamID: $teamID) {
						id 
						name 
						teamPosition 
						teamIcon 
						color 
					}
				}
				`),
			variables: {
								teamID: teamID
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPurchaserByID) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPurchaserByID, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPurchaserForCurrentUser(): Promise<[Purchaser[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPurchaserForCurrentUser {
					getPurchaserForCurrentUser {
						id 
						name 
						teamPosition 
						teamIcon 
						color 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPurchaserForCurrentUser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPurchaserForCurrentUser, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPurchaserGrids(pageId: number, virtualId: number): Promise<[Purchaser[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPurchaserGrids($pageId: Int!, $virtualId: Int!) {
					getPurchaserGrids(pageId: $pageId, virtualId: $virtualId) {
						id 
						name 
						teamPosition 
						teamIcon 
						color 
					}
				}
				`),
			variables: {
								pageId: pageId,
				virtualId: virtualId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPurchaserGrids) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPurchaserGrids, null];
	} catch (error) {
		return [null, error];
	}
}

async function getPurchasers(): Promise<[Purchaser[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getPurchasers {
					getPurchasers {
						id 
						name 
						teamPosition 
						teamIcon 
						color 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getPurchasers) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getPurchasers, null];
	} catch (error) {
		return [null, error];
	}
}

async function getRule(ruleId: number): Promise<[Rule | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getRule($ruleId: Int!) {
					getRule(ruleId: $ruleId) {
						id 
						hook 
						script 
						title 
					}
				}
				`),
			variables: {
								ruleId: ruleId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getRule) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getRule, null];
	} catch (error) {
		return [null, error];
	}
}

async function getRules(): Promise<[Rule[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getRules {
					getRules {
						id 
						hook 
						script 
						title 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getRules) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getRules, null];
	} catch (error) {
		return [null, error];
	}
}

async function getShoppingSectionsFromPage(pageId: number): Promise<[PageSections | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getShoppingSectionsFromPage($pageId: Int!) {
					getShoppingSectionsFromPage(pageId: $pageId) {
						pageID 
						teams {
							id 
							tag 
							name 
							color 
						}
						teamsForPlaceholder {
							key 
							value 
						}
					}
				}
				`),
			variables: {
								pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getShoppingSectionsFromPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getShoppingSectionsFromPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function getSortedProducts(pageId: number): Promise<[SortType[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getSortedProducts($pageId: Int!) {
					getSortedProducts(pageId: $pageId) {
						virtualId 
						positionTitle 
						productInfo {
							virtualId 
							articleNumber 
							productId 
							productPosition 
							teamId 
						}
					}
				}
				`),
			variables: {
								pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getSortedProducts) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getSortedProducts, null];
	} catch (error) {
		return [null, error];
	}
}

async function getStatements(): Promise<[Statement[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getStatements {
					getStatements {
						id 
						statement 
						name 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getStatements) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getStatements, null];
	} catch (error) {
		return [null, error];
	}
}

async function getTablesFromDatabase(): Promise<[string[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getTablesFromDatabase {
					getTablesFromDatabase 
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getTablesFromDatabase) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getTablesFromDatabase, null];
	} catch (error) {
		return [null, error];
	}
}

async function getTemplateInfo(templateId: number): Promise<[TemplateInputInfo | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getTemplateInfo($templateId: Int!) {
					getTemplateInfo(templateId: $templateId) {
						name 
						magazineType 
						copy 
					}
				}
				`),
			variables: {
								templateId: templateId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getTemplateInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getTemplateInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function getTimeTravelPoints(pageId: number): Promise<[TimeTravelPoint[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getTimeTravelPoints($pageId: Int!) {
					getTimeTravelPoints(pageId: $pageId) {
						timeTravelPointId 
						title 
						timestamp 
						pageId 
					}
				}
				`),
			variables: {
								pageId: pageId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getTimeTravelPoints) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getTimeTravelPoints, null];
	} catch (error) {
		return [null, error];
	}
}

async function getUser(userId: number): Promise<[UserProfile | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getUser($userId: Int!) {
					getUser(userId: $userId) {
						userId 
						userName 
						login 
						lastUpdateTimestamp 
						language 
						userMail 
						userPhone 
						role 
						purchasingIds 
					}
				}
				`),
			variables: {
								userId: userId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getUser) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getUser, null];
	} catch (error) {
		return [null, error];
	}
}

async function getUserInfo(): Promise<[UserInfo | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query getUserInfo {
					getUserInfo {
						client 
						userId 
						originalUserId 
						userName 
						lastUpdateTimestamp 
						language 
						userMail 
						userPhone 
						purchasingIds 
						isAdmin 
						isMarketing 
						isSuperAdmin 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.getUserInfo) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.getUserInfo, null];
	} catch (error) {
		return [null, error];
	}
}

async function imageSearch(filter: ImageSearchFilter): Promise<[ImageSearchResult[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query imageSearch($filter: ImageSearchFilter) {
					imageSearch(filter: $filter) {
						id 
						previewSmall 
						previewMedium 
						previewLarge 
						type 
						timestampUpdated 
						timestampCreated 
						isDeleted 
						name 
						dateTimeCreated 
						dateTimeUpdated 
					}
				}
				`),
			variables: {
								filter: filter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.imageSearch) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.imageSearch, null];
	} catch (error) {
		return [null, error];
	}
}

async function magazines(filter: QueryFilter): Promise<[Magazine[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query magazines($filter: QueryFilter) {
					magazines(filter: $filter) {
						magazineId 
						lock 
						name 
						numberOfPages 
						pages {
							pageId 
							isOnMarket 
							lock 
							projectId 
							marketId 
							magazineId 
							magazinePageCount 
							team {
								id 
								tag 
								name 
								color 
							}
							magazineTypeId 
							magazineTypeName 
							pagePosition 
							name 
							attributes {
								key 
								value 
							}
							products {
								productId 
								articleNumber 
								placeholderId 
								placeholderWidth 
								placeholderHeight 
								placeholderPosition 
								productPosition 
								productCustomFields {
									productCustomFieldId 
									productId 
									field 
									value 
								}
								productTemplate {
									productTemplateId 
									name 
								}
								productTemplateId 
								productTemplateName 
								productPictures {
									productJoinProductPictureId 
									productPictureId 
									teamId 
									isActive 
									originalFilePath 
									previewSmall 
									previewMedium 
									previewLarge 
									position 
									markedForDeletion 
									isDefault 
									name 
									dateTimeCreated 
									dateTimeUpdated 
									delete 
								}
								productLogos {
									productJoinProductLogoId 
									productLogoId 
									teamId 
									isActive 
									originalFilePath 
									previewSmall 
									previewMedium 
									previewLarge 
									position 
									markedForDeletion 
									name 
									dateTimeCreated 
									dateTimeUpdated 
									delete 
								}
								teamIcon 
								isVirtualArticle 
								virtualProjektId 
								virtualMagazineId 
								virtualPagePosition 
								virtualMarketId 
								virtualProjektName 
								virtualMagazineName 
								virtualMarketName 
								virtualOriginalLastChange 
								virtualAccordionIndex 
								teamColor 
								marketIds 
							}
							pageTemplateId 
							hooks 
						}
						magazineType 
						magazineTypeId 
						from 
						to 
						printNumber 
						mmW 
						mmH 
					}
				}
				`),
			variables: {
								filter: filter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.magazines) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.magazines, null];
	} catch (error) {
		return [null, error];
	}
}

async function newsletterImport(magazineID: number, newsletterImportArticles: NewsletterImportArticle[]): Promise<[Report | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation newsletterImport($magazineID: Int!, $newsletterImportArticles: [NewsletterImportArticle!]!) {
					newsletterImport(magazineID: $magazineID, newsletterImportArticles: $newsletterImportArticles) {
						jopId 
						success 
						errors {
							code 
							message 
							data {
								key 
								value 
							}
						}
						messages {
							code 
							message 
							data {
								key 
								value 
							}
						}
					}
				}
				`),
			variables: {
								magazineID: magazineID,
				newsletterImportArticles: newsletterImportArticles
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.newsletterImport) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.newsletterImport, null];
	} catch (error) {
		return [null, error];
	}
}

async function openPageTemplateInInDesign(pageTemplateId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation openPageTemplateInInDesign($pageTemplateId: Int!) {
					openPageTemplateInInDesign(pageTemplateId: $pageTemplateId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageTemplateId: pageTemplateId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.openPageTemplateInInDesign) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.openPageTemplateInInDesign, null];
	} catch (error) {
		return [null, error];
	}
}

async function openPictureInPhotoshop(type: string, pictureId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation openPictureInPhotoshop($type: String!, $pictureId: Int!) {
					openPictureInPhotoshop(type: $type, pictureId: $pictureId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								type: type,
				pictureId: pictureId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.openPictureInPhotoshop) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.openPictureInPhotoshop, null];
	} catch (error) {
		return [null, error];
	}
}

async function openProductTemplateInInDesign(productTemplateId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation openProductTemplateInInDesign($productTemplateId: Int!) {
					openProductTemplateInInDesign(productTemplateId: $productTemplateId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								productTemplateId: productTemplateId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.openProductTemplateInInDesign) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.openProductTemplateInInDesign, null];
	} catch (error) {
		return [null, error];
	}
}

async function pages(filter: QueryFilter): Promise<[Page[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query pages($filter: QueryFilter) {
					pages(filter: $filter) {
						pageId 
						isOnMarket 
						lock 
						projectId 
						marketId 
						magazineId 
						magazinePageCount 
						team {
							id 
							tag 
							name 
							color 
						}
						magazineTypeId 
						magazineTypeName 
						pagePosition 
						name 
						attributes {
							key 
							value 
						}
						products {
							productId 
							articleNumber 
							placeholderId 
							placeholderWidth 
							placeholderHeight 
							placeholderPosition 
							productPosition 
							productCustomFields {
								productCustomFieldId 
								productId 
								field 
								value 
							}
							productTemplate {
								productTemplateId 
								name 
							}
							productTemplateId 
							productTemplateName 
							productPictures {
								productJoinProductPictureId 
								productPictureId 
								teamId 
								isActive 
								originalFilePath 
								previewSmall 
								previewMedium 
								previewLarge 
								position 
								markedForDeletion 
								isDefault 
								name 
								dateTimeCreated 
								dateTimeUpdated 
								delete 
							}
							productLogos {
								productJoinProductLogoId 
								productLogoId 
								teamId 
								isActive 
								originalFilePath 
								previewSmall 
								previewMedium 
								previewLarge 
								position 
								markedForDeletion 
								name 
								dateTimeCreated 
								dateTimeUpdated 
								delete 
							}
							teamIcon 
							isVirtualArticle 
							virtualProjektId 
							virtualMagazineId 
							virtualPagePosition 
							virtualMarketId 
							virtualProjektName 
							virtualMagazineName 
							virtualMarketName 
							virtualOriginalLastChange 
							virtualAccordionIndex 
							teamColor 
							marketIds 
						}
						pageTemplateId 
						hooks 
					}
				}
				`),
			variables: {
								filter: filter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.pages) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.pages, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeNewProduktOnPage(pageId: number, articleNumber: string, purchaserId: number, virtualId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation placeNewProduktOnPage($pageId: Int!, $articleNumber: String!, $purchaserId: Int!, $virtualId: Int!) {
					placeNewProduktOnPage(pageId: $pageId, articleNumber: $articleNumber, purchaserId: $purchaserId, virtualId: $virtualId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				articleNumber: articleNumber,
				purchaserId: purchaserId,
				virtualId: virtualId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeNewProduktOnPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeNewProduktOnPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeProduct(input: placeProductInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query placeProduct($input: placeProductInput!) {
					placeProduct(input: $input) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								input: input
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeProduct) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeProduct, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeProductByRule(pageId: number, articleNumber: string, placeholderId: number, rule: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query placeProductByRule($pageId: Int!, $articleNumber: String!, $placeholderId: Int!, $rule: Int!) {
					placeProductByRule(pageId: $pageId, articleNumber: $articleNumber, placeholderId: $placeholderId, rule: $rule) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								pageId: pageId,
				articleNumber: articleNumber,
				placeholderId: placeholderId,
				rule: rule
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeProductByRule) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeProductByRule, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeProductOnMarket(data: PlaceProductOnMarketInput): Promise<[CheckPlaceResultMarket | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation placeProductOnMarket($data: PlaceProductOnMarketInput!) {
					placeProductOnMarket(data: $data) {
						success 
						articleNumber 
						marketIds 
						code 
					}
				}
				`),
			variables: {
								data: data
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeProductOnMarket) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeProductOnMarket, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeProductOnMarketFromListView(data: PlaceProductsOnPageInput): Promise<[CheckPlaceResultMarket | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation placeProductOnMarketFromListView($data: PlaceProductsOnPageInput!) {
					placeProductOnMarketFromListView(data: $data) {
						success 
						articleNumber 
						marketIds 
						code 
					}
				}
				`),
			variables: {
								data: data
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeProductOnMarketFromListView) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeProductOnMarketFromListView, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeProductOnPage(input: PlaceProductOnPageInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query placeProductOnPage($input: PlaceProductOnPageInput!) {
					placeProductOnPage(input: $input) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								input: input
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeProductOnPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeProductOnPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeProductOnPageFromClipboard(clipboard: ClipboardInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation placeProductOnPageFromClipboard($clipboard: ClipboardInput!) {
					placeProductOnPageFromClipboard(clipboard: $clipboard) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								clipboard: clipboard
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeProductOnPageFromClipboard) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeProductOnPageFromClipboard, null];
	} catch (error) {
		return [null, error];
	}
}

async function placeProductsOnPage(input: PlaceProductsOnPageInput): Promise<[Report | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query placeProductsOnPage($input: PlaceProductsOnPageInput!) {
					placeProductsOnPage(input: $input) {
						jopId 
						success 
						errors {
							code 
							message 
							data {
								key 
								value 
							}
						}
						messages {
							code 
							message 
							data {
								key 
								value 
							}
						}
					}
				}
				`),
			variables: {
								input: input
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.placeProductsOnPage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.placeProductsOnPage, null];
	} catch (error) {
		return [null, error];
	}
}

async function productCustomFields(filter: QueryFilter): Promise<[ProductCustomField[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query productCustomFields($filter: QueryFilter) {
					productCustomFields(filter: $filter) {
						productCustomFieldId 
						productId 
						field 
						value 
					}
				}
				`),
			variables: {
								filter: filter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.productCustomFields) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.productCustomFields, null];
	} catch (error) {
		return [null, error];
	}
}

async function productFormFields(): Promise<[ProductFormFieldGroup[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query productFormFields {
					productFormFields {
						type 
						name 
						fields {
							type 
							field 
							label 
							readOnly 
							image 
							value 
						}
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.productFormFields) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.productFormFields, null];
	} catch (error) {
		return [null, error];
	}
}

async function productTemplates(filter: QueryFilter): Promise<[ProductTemplate[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query productTemplates($filter: QueryFilter) {
					productTemplates(filter: $filter) {
						productTemplateId 
						name 
					}
				}
				`),
			variables: {
								filter: filter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.productTemplates) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.productTemplates, null];
	} catch (error) {
		return [null, error];
	}
}

async function products(filter: QueryFilter): Promise<[Product[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query products($filter: QueryFilter) {
					products(filter: $filter) {
						productId 
						articleNumber 
						placeholderId 
						placeholderWidth 
						placeholderHeight 
						placeholderPosition 
						productPosition 
						productCustomFields {
							productCustomFieldId 
							productId 
							field 
							value 
						}
						productTemplate {
							productTemplateId 
							name 
						}
						productTemplateId 
						productTemplateName 
						productPictures {
							productJoinProductPictureId 
							productPictureId 
							teamId 
							isActive 
							originalFilePath 
							previewSmall 
							previewMedium 
							previewLarge 
							position 
							markedForDeletion 
							isDefault 
							name 
							dateTimeCreated 
							dateTimeUpdated 
							delete 
						}
						productLogos {
							productJoinProductLogoId 
							productLogoId 
							teamId 
							isActive 
							originalFilePath 
							previewSmall 
							previewMedium 
							previewLarge 
							position 
							markedForDeletion 
							name 
							dateTimeCreated 
							dateTimeUpdated 
							delete 
						}
						teamIcon 
						isVirtualArticle 
						virtualProjektId 
						virtualMagazineId 
						virtualPagePosition 
						virtualMarketId 
						virtualProjektName 
						virtualMagazineName 
						virtualMarketName 
						virtualOriginalLastChange 
						virtualAccordionIndex 
						teamColor 
						marketIds 
					}
				}
				`),
			variables: {
								filter: filter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.products) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.products, null];
	} catch (error) {
		return [null, error];
	}
}

async function projects(filter: QueryFilter): Promise<[Project[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query projects($filter: QueryFilter) {
					projects(filter: $filter) {
						projectId 
						name 
						startTimestamp 
						endTimestamp 
						lock 
						isActive 
						magazines {
							magazineId 
							lock 
							name 
							numberOfPages 
							pages {
								pageId 
								isOnMarket 
								lock 
								projectId 
								marketId 
								magazineId 
								magazinePageCount 
								team {
									id 
									tag 
									name 
									color 
								}
								magazineTypeId 
								magazineTypeName 
								pagePosition 
								name 
								attributes {
									key 
									value 
								}
								products {
									productId 
									articleNumber 
									placeholderId 
									placeholderWidth 
									placeholderHeight 
									placeholderPosition 
									productPosition 
									productCustomFields {
										productCustomFieldId 
										productId 
										field 
										value 
									}
									productTemplate {
										productTemplateId 
										name 
									}
									productTemplateId 
									productTemplateName 
									productPictures {
										productJoinProductPictureId 
										productPictureId 
										teamId 
										isActive 
										originalFilePath 
										previewSmall 
										previewMedium 
										previewLarge 
										position 
										markedForDeletion 
										isDefault 
										name 
										dateTimeCreated 
										dateTimeUpdated 
										delete 
									}
									productLogos {
										productJoinProductLogoId 
										productLogoId 
										teamId 
										isActive 
										originalFilePath 
										previewSmall 
										previewMedium 
										previewLarge 
										position 
										markedForDeletion 
										name 
										dateTimeCreated 
										dateTimeUpdated 
										delete 
									}
									teamIcon 
									isVirtualArticle 
									virtualProjektId 
									virtualMagazineId 
									virtualPagePosition 
									virtualMarketId 
									virtualProjektName 
									virtualMagazineName 
									virtualMarketName 
									virtualOriginalLastChange 
									virtualAccordionIndex 
									teamColor 
									marketIds 
								}
								pageTemplateId 
								hooks 
							}
							magazineType 
							magazineTypeId 
							from 
							to 
							printNumber 
							mmW 
							mmH 
						}
					}
				}
				`),
			variables: {
								filter: filter
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.projects) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.projects, null];
	} catch (error) {
		return [null, error];
	}
}

async function renameInDesignTemplate(templateId: number, type: string, name: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation renameInDesignTemplate($templateId: Int!, $type: String!, $name: String!) {
					renameInDesignTemplate(templateId: $templateId, type: $type, name: $name) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								templateId: templateId,
				type: type,
				name: name
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.renameInDesignTemplate) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.renameInDesignTemplate, null];
	} catch (error) {
		return [null, error];
	}
}

async function renameInDesignTemplateCategory(categoryId: number, name: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation renameInDesignTemplateCategory($categoryId: Int!, $name: String!) {
					renameInDesignTemplateCategory(categoryId: $categoryId, name: $name) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								categoryId: categoryId,
				name: name
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.renameInDesignTemplateCategory) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.renameInDesignTemplateCategory, null];
	} catch (error) {
		return [null, error];
	}
}

async function restoreTimeTravelPoint(timeTravelPointId: number): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation restoreTimeTravelPoint($timeTravelPointId: Int!) {
					restoreTimeTravelPoint(timeTravelPointId: $timeTravelPointId) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								timeTravelPointId: timeTravelPointId
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.restoreTimeTravelPoint) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.restoreTimeTravelPoint, null];
	} catch (error) {
		return [null, error];
	}
}

async function runAbracadabra(data: AbracadabraInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation runAbracadabra($data: AbracadabraInput!) {
					runAbracadabra(data: $data) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								data: data
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.runAbracadabra) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.runAbracadabra, null];
	} catch (error) {
		return [null, error];
	}
}

async function saveArticleNumber(data: SaveArticleNumberInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation saveArticleNumber($data: SaveArticleNumberInput!) {
					saveArticleNumber(data: $data) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								data: data
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.saveArticleNumber) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.saveArticleNumber, null];
	} catch (error) {
		return [null, error];
	}
}

async function saveInDesignRule(rule: InDesignRuleInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation saveInDesignRule($rule: InDesignRuleInput!) {
					saveInDesignRule(rule: $rule) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								rule: rule
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.saveInDesignRule) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.saveInDesignRule, null];
	} catch (error) {
		return [null, error];
	}
}

async function saveListView(data: SaveListViewInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation saveListView($data: SaveListViewInput!) {
					saveListView(data: $data) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								data: data
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.saveListView) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.saveListView, null];
	} catch (error) {
		return [null, error];
	}
}

async function saveNewArticleNumber(articleNumber: string, oldArticleNumber: string): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation saveNewArticleNumber($articleNumber: String!, $oldArticleNumber: String!) {
					saveNewArticleNumber(articleNumber: $articleNumber, oldArticleNumber: $oldArticleNumber) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								articleNumber: articleNumber,
				oldArticleNumber: oldArticleNumber
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.saveNewArticleNumber) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.saveNewArticleNumber, null];
	} catch (error) {
		return [null, error];
	}
}

async function saveNewsLetterImport(data: NewsLetterData): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation saveNewsLetterImport($data: NewsLetterData!) {
					saveNewsLetterImport(data: $data) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								data: data
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.saveNewsLetterImport) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.saveNewsLetterImport, null];
	} catch (error) {
		return [null, error];
	}
}

async function savePage(page: PageInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation savePage($page: PageInput!) {
					savePage(page: $page) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								page: page
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.savePage) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.savePage, null];
	} catch (error) {
		return [null, error];
	}
}

async function saveTableData(tableName: string, data: TableDataInput[]): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation saveTableData($tableName: String!, $data: [TableDataInput!]!) {
					saveTableData(tableName: $tableName, data: $data) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								tableName: tableName,
				data: data
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.saveTableData) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.saveTableData, null];
	} catch (error) {
		return [null, error];
	}
}

async function searchClipboard(): Promise<[Clipboard[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query searchClipboard {
					searchClipboard {
						clipboardId 
						clipboardProduktId 
						clipboardPageID 
						clipboardTime 
						clipboardUserId 
						clipboardVision 
						articleID 
						articleNumber 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.searchClipboard) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.searchClipboard, null];
	} catch (error) {
		return [null, error];
	}
}

async function searchWhereArticleNumberIs(articleNumber: string): Promise<[ArticleNumberSearch[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query searchWhereArticleNumberIs($articleNumber: String!) {
					searchWhereArticleNumberIs(articleNumber: $articleNumber) {
						id 
						produktName 
						pagePosition 
						magazineName 
						marketName 
						marketDescription 
						magazineId 
						marketId 
						projektId 
					}
				}
				`),
			variables: {
								articleNumber: articleNumber
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.searchWhereArticleNumberIs) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.searchWhereArticleNumberIs, null];
	} catch (error) {
		return [null, error];
	}
}

async function sortProducts(sort: SortInputs[]): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation sortProducts($sort: [SortInputs]!) {
					sortProducts(sort: $sort) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								sort: sort
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.sortProducts) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.sortProducts, null];
	} catch (error) {
		return [null, error];
	}
}

async function teams(): Promise<[Team[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query teams {
					teams {
						id 
						tag 
						name 
						color 
					}
				}
				`),
			variables: {
				
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.teams) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.teams, null];
	} catch (error) {
		return [null, error];
	}
}

async function templateSearch(template: TemplateInput): Promise<[TemplateSearchResult[] | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query templateSearch($template: TemplateInput!) {
					templateSearch(template: $template) {
						templateId 
						templateName 
						templateHeight 
						templateWidth 
						templateTimestamp 
					}
				}
				`),
			variables: {
								template: template
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.templateSearch) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.templateSearch, null];
	} catch (error) {
		return [null, error];
	}
}

async function testtest(test: number): Promise<[number | null, any | null]> {
	try {
		const response = await apolloClient.query({
			query: gql(`
				 query testtest($test: Int!) {
					testtest(test: $test) 
				}
				`),
			variables: {
								test: test
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.testtest) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.testtest, null];
	} catch (error) {
		return [null, error];
	}
}

async function updateApiKey(apiKey: ApiKeyInput): Promise<[Success | null, any | null]> {
	try {
		const response = await apolloClient.mutate({
			mutation: gql(`
				 mutation updateApiKey($apiKey: ApiKeyInput!) {
					updateApiKey(apiKey: $apiKey) {
						success 
						code 
						message 
						values {
							key 
							value 
						}
						id 
					}
				}
				`),
			variables: {
								apiKey: apiKey
			}
		});
	
		if (response.errors && response.errors.length > 0) {
			return [null, response.errors];
		}
	
		if (!response.data || !response.data.updateApiKey) {
			return [null, new Error(`Invalid response structure`)];
		}
	
		return [response.data.updateApiKey, null];
	} catch (error) {
		return [null, error];
	}
}

export const query = {
	activityHistory,
	debug,
	deleteProductFromPage,
	getAccordionIndex,
	getAllMarkets,
	getAllUser,
	getApiKey,
	getApiKeys,
	getArticleFromMarkets,
	getArticleInformation,
	getArticleNumbers,
	getArticleNumbersByPageId,
	getArticleTemplateGroups,
	getAsset,
	getBaseArticle,
	getDataFromTable,
	getFieldLabel,
	getFormular,
	getFormularInfos,
	getFormularInfosGroup,
	getFormularName,
	getFormularNames,
	getFormularValue,
	getGridByPage,
	getGridByTemplateId,
	getImageByPath,
	getImportClass,
	getInDesignRules,
	getInDesignTemplateCategories,
	getInDesignTemplateInfo,
	getInDesignTemplates,
	getJop,
	getMagazine,
	getMagazineType,
	getMagazineTypes,
	getMagazinesWithIdAndName,
	getMarket,
	getMarketCustomField,
	getMarketCustomFieldValues,
	getMarkets,
	getMarketsInfo,
	getMarketsStatus,
	getMarketsWithIdAndName,
	getPackages,
	getPage,
	getPageInfo,
	getPageList,
	getPageTemplateGroups,
	getPageTemplates,
	getPageTemplatesByFilter,
	getPageWithIdAndNameBy,
	getPagesByMarketID,
	getPagesWithIdAndName,
	getPlaceholdersForMarkets,
	getPrintInfo,
	getProductCustomField,
	getProductCustomFields,
	getProductFormHeader,
	getProductFormHeaders,
	getProductFormList,
	getProductFormListMarket,
	getProductsWithIdAndName,
	getProjectsForCurrentUser,
	getProjectsWithIdAndName,
	getPurchaserByID,
	getPurchaserForCurrentUser,
	getPurchaserGrids,
	getPurchasers,
	getRule,
	getRules,
	getShoppingSectionsFromPage,
	getSortedProducts,
	getStatements,
	getTablesFromDatabase,
	getTemplateInfo,
	getTimeTravelPoints,
	getUser,
	getUserInfo,
	imageSearch,
	magazines,
	pages,
	placeProduct,
	placeProductByRule,
	placeProductOnPage,
	placeProductsOnPage,
	productCustomFields,
	productFormFields,
	productTemplates,
	products,
	projects,
	searchClipboard,
	searchWhereArticleNumberIs,
	teams,
	templateSearch,
	testtest
};
export const mutation = {
	JSONExport,
	articleLink,
	changeArticle,
	changeImageLock,
	changeMagazineLock,
	changePageLock,
	changePageTemplate,
	changePageTemplateWithProducts,
	changeProjectLock,
	checkIfArticleIsOnMagazinePage,
	checkIfProductIsOnMarket,
	clearPurchaserGroup,
	copyDataFromLinktArticle,
	creatCustomField,
	createApiKey,
	createArtikelNumber,
	createFormular,
	createInDesignTemplate,
	createInDesignTemplateCategory,
	createInDesignTemplateVariant,
	createMagazine,
	createMagazineType,
	createMarket,
	createNewField,
	createOrUpdateRule,
	createPage,
	createProduct,
	createProject,
	createStatement,
	createTeam,
	createTimeTravelPoint,
	createUser,
	deleteAllClipboardTaps,
	deleteApiKey,
	deleteArticle,
	deleteArticleFromAllMarkets,
	deleteClipboard,
	deleteFormular,
	deleteInDesignTemplate,
	deleteInDesignTemplateCategory,
	deleteMagazine,
	deleteMagazineType,
	deletePage,
	deleteProductCustomField,
	deleteProject,
	deletePurchaser,
	deleteRule,
	deleteUser,
	editBaseArticle,
	editClipboard,
	editFromField,
	editGridForPage,
	editGridForTemplate,
	editImage,
	editImageFavorite,
	editImagesClass,
	editImagesPurchaser,
	editInDesignTemplateInfo,
	editMagazine,
	editMagazineType,
	editMarket,
	editOnSetDelete,
	editPage,
	editPageName,
	editPageTeams,
	editPageTemplate,
	editPageTemplateInfo,
	editProductCustomField,
	editProject,
	editTeam,
	editUser,
	editUserInformation,
	editUserPassword,
	excelImport,
	executeSqlCommand,
	exportImages,
	newsletterImport,
	openPageTemplateInInDesign,
	openPictureInPhotoshop,
	openProductTemplateInInDesign,
	placeNewProduktOnPage,
	placeProductOnMarket,
	placeProductOnMarketFromListView,
	placeProductOnPageFromClipboard,
	renameInDesignTemplate,
	renameInDesignTemplateCategory,
	restoreTimeTravelPoint,
	runAbracadabra,
	saveArticleNumber,
	saveInDesignRule,
	saveListView,
	saveNewArticleNumber,
	saveNewsLetterImport,
	savePage,
	saveTableData,
	sortProducts,
	updateApiKey
};

